/*! jQuery v3.1.1 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.1.1",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null==a?f.call(this):a<0?this[a+this.length]:this[a]},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=r.isArray(d)))?(e?(e=!1,f=c&&r.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0&&("form"in a||"label"in a)},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+sa(o[h]);r=o.join(","),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return function(b){return"form"in b?b.parentNode&&b.disabled===!1?"label"in b?"label"in b.parentNode?b.parentNode.disabled===a:b.disabled===a:b.isDisabled===a||b.isDisabled!==!a&&ea(b)===a:b.disabled===a:"label"in b&&b.disabled===a}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}}):(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c,d,e,f=b.getElementById(a);if(f){if(c=f.getAttributeNode("id"),c&&c.value===a)return[f];e=b.getElementsByName(a),d=0;while(f=e[d++])if(c=f.getAttributeNode("id"),c&&c.value===a)return[f]}return[]}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+"").replace(ba,ca)},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[c<0?c+b:c]}),even:pa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e);return!1}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}return!1}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;d<e;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&ya(a.slice(i,e)),e<f&&ya(a=a.slice(e)),e<f&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,c,e){var f,i,j,k,l,m="function"==typeof a&&a,n=!e&&g(a=m.selector||a);if(c=c||[],1===n.length){if(i=n[0]=n[0].slice(0),i.length>2&&"ID"===(j=i[0]).type&&9===b.nodeType&&p&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(_,aa),b)||[])[0],!b)return c;m&&(b=b.parentNode),a=a.slice(i.shift().value.length)}f=V.needsContext.test(a)?0:i.length;while(f--){if(j=i[f],d.relative[k=j.type])break;if((l=d.find[k])&&(e=l(j.matches[0].replace(_,aa),$.test(i[0].type)&&qa(b.parentNode)||b))){if(i.splice(f,1),a=e.length&&sa(i),!a)return G.apply(c,e),c;break}}}return(m||h(a,n))(e,b,!p,c,!b||$.test(a)&&qa(b.parentNode)||b),c},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext,B=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,C=/^.[^:#\[\.,]*$/;function D(a,b,c){return r.isFunction(b)?r.grep(a,function(a,d){return!!b.call(a,d,a)!==c}):b.nodeType?r.grep(a,function(a){return a===b!==c}):"string"!=typeof b?r.grep(a,function(a){return i.call(b,a)>-1!==c}):C.test(b)?r.filter(b,a,c):(b=r.filter(b,a),r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType}))}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(D(this,a||[],!1))},not:function(a){return this.pushStack(D(this,a||[],!0))},is:function(a){return!!D(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var E,F=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,G=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||E,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:F.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),B.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};G.prototype=r.fn,E=r(d);var H=/^(?:parents|prev(?:Until|All))/,I={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function J(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return J(a,"nextSibling")},prev:function(a){return J(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return a.contentDocument||r.merge([],a.childNodes)}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(I[a]||r.uniqueSort(e),H.test(a)&&e.reverse()),this.pushStack(e)}});var K=/[^\x20\t\r\n\f]+/g;function L(a){var b={};return r.each(a.match(K)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?L(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function M(a){return a}function N(a){throw a}function O(a,b,c){var d;try{a&&r.isFunction(d=a.promise)?d.call(a).done(b).fail(c):a&&r.isFunction(d=a.then)?d.call(a,b,c):b.call(void 0,a)}catch(a){c.call(void 0,a)}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},"catch":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,M,e),g(f,c,N,e)):(f++,j.call(a,g(f,c,M,e),g(f,c,N,e),g(f,c,M,c.notifyWith))):(d!==M&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==N&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:M,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:M)),c[2][3].add(g(0,a,r.isFunction(d)?d:N))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(O(a,g.done(h(c)).resolve,g.reject),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)O(e[c],h(c),g.reject);return g.promise()}});var P=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&P.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var Q=r.Deferred();r.fn.ready=function(a){return Q.then(a)["catch"](function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,holdReady:function(a){a?r.readyWait++:r.ready(!0)},ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||Q.resolveWith(d,[r]))}}),r.ready.then=Q.then;function R(){d.removeEventListener("DOMContentLoaded",R),
a.removeEventListener("load",R),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",R),a.addEventListener("load",R));var S=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)S(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},T=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function U(){this.expando=r.expando+U.uid++}U.uid=1,U.prototype={cache:function(a){var b=a[this.expando];return b||(b={},T(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){r.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(K)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var V=new U,W=new U,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Y=/[A-Z]/g;function Z(a){return"true"===a||"false"!==a&&("null"===a?null:a===+a+""?+a:X.test(a)?JSON.parse(a):a)}function $(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Y,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c=Z(c)}catch(e){}W.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return W.hasData(a)||V.hasData(a)},data:function(a,b,c){return W.access(a,b,c)},removeData:function(a,b){W.remove(a,b)},_data:function(a,b,c){return V.access(a,b,c)},_removeData:function(a,b){V.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=W.get(f),1===f.nodeType&&!V.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),$(f,d,e[d])));V.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){W.set(this,a)}):S(this,function(b){var c;if(f&&void 0===b){if(c=W.get(f,a),void 0!==c)return c;if(c=$(f,a),void 0!==c)return c}else this.each(function(){W.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){W.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=V.get(a,b),c&&(!d||r.isArray(c)?d=V.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return V.get(a,c)||V.access(a,c,{empty:r.Callbacks("once memory").add(function(){V.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=V.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var _=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,aa=new RegExp("^(?:([+-])=|)("+_+")([a-z%]*)$","i"),ba=["Top","Right","Bottom","Left"],ca=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function ea(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&aa.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var fa={};function ga(a){var b,c=a.ownerDocument,d=a.nodeName,e=fa[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),fa[d]=e,e)}function ha(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=V.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&ca(d)&&(e[f]=ga(d))):"none"!==c&&(e[f]="none",V.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ha(this,!0)},hide:function(){return ha(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){ca(this)?r(this).show():r(this).hide()})}});var ia=/^(?:checkbox|radio)$/i,ja=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,ka=/^$|\/(?:java|ecma)script/i,la={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};la.optgroup=la.option,la.tbody=la.tfoot=la.colgroup=la.caption=la.thead,la.th=la.td;function ma(a,b){var c;return c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[],void 0===b||b&&r.nodeName(a,b)?r.merge([a],c):c}function na(a,b){for(var c=0,d=a.length;c<d;c++)V.set(a[c],"globalEval",!b||V.get(b[c],"globalEval"))}var oa=/<|&#?\w+;/;function pa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(oa.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ja.exec(f)||["",""])[1].toLowerCase(),i=la[h]||la._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=ma(l.appendChild(f),"script"),j&&na(g),c){k=0;while(f=g[k++])ka.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var qa=d.documentElement,ra=/^key/,sa=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,ta=/^([^.]*)(?:\.(.+)|)/;function ua(){return!0}function va(){return!1}function wa(){try{return d.activeElement}catch(a){}}function xa(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)xa(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=va;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(qa,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(K)||[""],j=b.length;while(j--)h=ta.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=V.hasData(a)&&V.get(a);if(q&&(i=q.events)){b=(b||"").match(K)||[""],j=b.length;while(j--)if(h=ta.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&V.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(V.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&!("click"===a.type&&a.button>=1))for(;j!==this;j=j.parentNode||this)if(1===j.nodeType&&("click"!==a.type||j.disabled!==!0)){for(f=[],g={},c=0;c<i;c++)d=b[c],e=d.selector+" ",void 0===g[e]&&(g[e]=d.needsContext?r(e,this).index(j)>-1:r.find(e,this,null,[j]).length),g[e]&&f.push(d);f.length&&h.push({elem:j,handlers:f})}return j=this,i<b.length&&h.push({elem:j,handlers:b.slice(i)}),h},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==wa()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===wa()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&r.nodeName(this,"input"))return this.click(),!1},_default:function(a){return r.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ua:va,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:va,isPropagationStopped:va,isImmediatePropagationStopped:va,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ua,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ua,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ua,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&ra.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&sa.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return xa(this,a,b,c,d)},one:function(a,b,c,d){return xa(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=va),this.each(function(){r.event.remove(this,a,c,b)})}});var ya=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,za=/<script|<style|<link/i,Aa=/checked\s*(?:[^=]|=\s*.checked.)/i,Ba=/^true\/(.*)/,Ca=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Da(a,b){return r.nodeName(a,"table")&&r.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function Ea(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Fa(a){var b=Ba.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Ga(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(V.hasData(a)&&(f=V.access(a),g=V.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}W.hasData(a)&&(h=W.access(a),i=r.extend({},h),W.set(b,i))}}function Ha(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ia.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ia(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&Aa.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ia(f,b,c,d)});if(m&&(e=pa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(ma(e,"script"),Ea),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,ma(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Fa),l=0;l<i;l++)j=h[l],ka.test(j.type||"")&&!V.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Ca,""),k))}return a}function Ja(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(ma(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&na(ma(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(ya,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=ma(h),f=ma(a),d=0,e=f.length;d<e;d++)Ha(f[d],g[d]);if(b)if(c)for(f=f||ma(a),g=g||ma(h),d=0,e=f.length;d<e;d++)Ga(f[d],g[d]);else Ga(a,h);return g=ma(h,"script"),g.length>0&&na(g,!i&&ma(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(T(c)){if(b=c[V.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[V.expando]=void 0}c[W.expando]&&(c[W.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ja(this,a,!0)},remove:function(a){return Ja(this,a)},text:function(a){return S(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ia(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Da(this,a);b.appendChild(a)}})},prepend:function(){return Ia(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Da(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ia(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ia(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(ma(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return S(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!za.test(a)&&!la[(ja.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(ma(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ia(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(ma(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var Ka=/^margin/,La=new RegExp("^("+_+")(?!px)[a-z%]+$","i"),Ma=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",qa.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,qa.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Na(a,b,c){var d,e,f,g,h=a.style;return c=c||Ma(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&La.test(g)&&Ka.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Oa(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Pa=/^(none|table(?!-c[ea]).+)/,Qa={position:"absolute",visibility:"hidden",display:"block"},Ra={letterSpacing:"0",fontWeight:"400"},Sa=["Webkit","Moz","ms"],Ta=d.createElement("div").style;function Ua(a){if(a in Ta)return a;var b=a[0].toUpperCase()+a.slice(1),c=Sa.length;while(c--)if(a=Sa[c]+b,a in Ta)return a}function Va(a,b,c){var d=aa.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Wa(a,b,c,d,e){var f,g=0;for(f=c===(d?"border":"content")?4:"width"===b?1:0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+ba[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+ba[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+ba[f]+"Width",!0,e))):(g+=r.css(a,"padding"+ba[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+ba[f]+"Width",!0,e)));return g}function Xa(a,b,c){var d,e=!0,f=Ma(a),g="border-box"===r.css(a,"boxSizing",!1,f);if(a.getClientRects().length&&(d=a.getBoundingClientRect()[b]),d<=0||null==d){if(d=Na(a,b,f),(d<0||null==d)&&(d=a.style[b]),La.test(d))return d;e=g&&(o.boxSizingReliable()||d===a.style[b]),d=parseFloat(d)||0}return d+Wa(a,b,c||(g?"border":"content"),e,f)+"px"}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Na(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=a.style;return b=r.cssProps[h]||(r.cssProps[h]=Ua(h)||h),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=aa.exec(c))&&e[1]&&(c=ea(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b);return b=r.cssProps[h]||(r.cssProps[h]=Ua(h)||h),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Na(a,b,d)),"normal"===e&&b in Ra&&(e=Ra[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Pa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?Xa(a,b,d):da(a,Qa,function(){return Xa(a,b,d)})},set:function(a,c,d){var e,f=d&&Ma(a),g=d&&Wa(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=aa.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Va(a,c,g)}}}),r.cssHooks.marginLeft=Oa(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Na(a,"marginLeft"))||a.getBoundingClientRect().left-da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+ba[d]+b]=f[d]||f[d-2]||f[0];return e}},Ka.test(a)||(r.cssHooks[a+b].set=Va)}),r.fn.extend({css:function(a,b){return S(this,function(a,b,c){var d,e,f={},g=0;if(r.isArray(b)){for(d=Ma(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function Ya(a,b,c,d,e){return new Ya.prototype.init(a,b,c,d,e)}r.Tween=Ya,Ya.prototype={constructor:Ya,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=Ya.propHooks[this.prop];return a&&a.get?a.get(this):Ya.propHooks._default.get(this)},run:function(a){var b,c=Ya.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ya.propHooks._default.set(this),this}},Ya.prototype.init.prototype=Ya.prototype,Ya.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},Ya.propHooks.scrollTop=Ya.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=Ya.prototype.init,r.fx.step={};var Za,$a,_a=/^(?:toggle|show|hide)$/,ab=/queueHooks$/;function bb(){$a&&(a.requestAnimationFrame(bb),r.fx.tick())}function cb(){return a.setTimeout(function(){Za=void 0}),Za=r.now()}function db(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=ba[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function eb(a,b,c){for(var d,e=(hb.tweeners[b]||[]).concat(hb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function fb(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&ca(a),q=V.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],_a.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=V.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ha([a],!0),j=a.style.display||j,k=r.css(a,"display"),ha([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=V.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ha([a],!0),m.done(function(){p||ha([a]),V.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=eb(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function gb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],r.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function hb(a,b,c){var d,e,f=0,g=hb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Za||cb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:Za||cb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(gb(k,j.opts.specialEasing);f<g;f++)if(d=hb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,eb,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}r.Animation=r.extend(hb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return ea(c.elem,a,aa.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(K);for(var c,d=0,e=a.length;d<e;d++)c=a[d],hb.tweeners[c]=hb.tweeners[c]||[],hb.tweeners[c].unshift(b)},prefilters:[fb],prefilter:function(a,b){b?hb.prefilters.unshift(a):hb.prefilters.push(a)}}),r.speed=function(a,b,c){var e=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off||d.hidden?e.duration=0:"number"!=typeof e.duration&&(e.duration in r.fx.speeds?e.duration=r.fx.speeds[e.duration]:e.duration=r.fx.speeds._default),null!=e.queue&&e.queue!==!0||(e.queue="fx"),e.old=e.complete,e.complete=function(){r.isFunction(e.old)&&e.old.call(this),e.queue&&r.dequeue(this,e.queue)},e},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(ca).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=hb(this,r.extend({},a),f);(e||V.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=V.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&ab.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=V.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(db(b,!0),a,d,e)}}),r.each({slideDown:db("show"),slideUp:db("hide"),slideToggle:db("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(Za=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),Za=void 0},r.fx.timer=function(a){r.timers.push(a),a()?r.fx.start():r.timers.pop()},r.fx.interval=13,r.fx.start=function(){$a||($a=a.requestAnimationFrame?a.requestAnimationFrame(bb):a.setInterval(r.fx.tick,r.fx.interval))},r.fx.stop=function(){a.cancelAnimationFrame?a.cancelAnimationFrame($a):a.clearInterval($a),$a=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var ib,jb=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return S(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?ib:void 0)),
void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&r.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(K);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),ib={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=jb[b]||r.find.attr;jb[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=jb[g],jb[g]=e,e=null!=c(a,b,d)?g:null,jb[g]=f),e}});var kb=/^(?:input|select|textarea|button)$/i,lb=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return S(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):kb.test(a.nodeName)||lb.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});function mb(a){var b=a.match(K)||[];return b.join(" ")}function nb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,nb(this)))});if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=nb(c),d=1===c.nodeType&&" "+mb(e)+" "){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=mb(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,nb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(K)||[];while(c=this[i++])if(e=nb(c),d=1===c.nodeType&&" "+mb(e)+" "){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=mb(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,nb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(K)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=nb(this),b&&V.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":V.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+mb(nb(c))+" ").indexOf(b)>-1)return!0;return!1}});var ob=/\r/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":r.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(ob,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:mb(r.text(a))}},select:{get:function(a){var b,c,d,e=a.options,f=a.selectedIndex,g="select-one"===a.type,h=g?null:[],i=g?f+1:e.length;for(d=f<0?i:g?f:0;d<i;d++)if(c=e[d],(c.selected||d===f)&&!c.disabled&&(!c.parentNode.disabled||!r.nodeName(c.parentNode,"optgroup"))){if(b=r(c).val(),g)return b;h.push(b)}return h},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(r.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var pb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!pb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,pb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(V.get(h,"events")||{})[b.type]&&V.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&T(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!T(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=V.access(d,b);e||d.addEventListener(a,c,!0),V.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=V.access(d,b)-1;e?V.access(d,b,e):(d.removeEventListener(a,c,!0),V.remove(d,b))}}});var qb=a.location,rb=r.now(),sb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var tb=/\[\]$/,ub=/\r?\n/g,vb=/^(?:submit|button|image|reset|file)$/i,wb=/^(?:input|select|textarea|keygen)/i;function xb(a,b,c,d){var e;if(r.isArray(b))r.each(b,function(b,e){c||tb.test(a)?d(a,e):xb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)xb(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(r.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)xb(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&wb.test(this.nodeName)&&!vb.test(a)&&(this.checked||!ia.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:r.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(ub,"\r\n")}}):{name:b.name,value:c.replace(ub,"\r\n")}}).get()}});var yb=/%20/g,zb=/#.*$/,Ab=/([?&])_=[^&]*/,Bb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Cb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Db=/^(?:GET|HEAD)$/,Eb=/^\/\//,Fb={},Gb={},Hb="*/".concat("*"),Ib=d.createElement("a");Ib.href=qb.href;function Jb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(K)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Kb(a,b,c,d){var e={},f=a===Gb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Lb(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Mb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Nb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:qb.href,type:"GET",isLocal:Cb.test(qb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Hb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Lb(Lb(a,r.ajaxSettings),b):Lb(r.ajaxSettings,a)},ajaxPrefilter:Jb(Fb),ajaxTransport:Jb(Gb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Bb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||qb.href)+"").replace(Eb,qb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(K)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Ib.protocol+"//"+Ib.host!=j.protocol+"//"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Kb(Fb,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Db.test(o.type),f=o.url.replace(zb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(yb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(sb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Ab,"$1"),n=(sb.test(f)?"&":"?")+"_="+rb++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Hb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Kb(Gb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,"No Transport");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Mb(o,y,d)),v=Nb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Ob={0:200,1223:204},Pb=r.ajaxSettings.xhr();o.cors=!!Pb&&"withCredentials"in Pb,o.ajax=Pb=!!Pb,r.ajaxTransport(function(b){var c,d;if(o.cors||Pb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Ob[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Qb=[],Rb=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Qb.pop()||r.expando+"_"+rb++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Rb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Rb.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Rb,"$1"+e):b.jsonp!==!1&&(b.url+=(sb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Qb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=B.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=pa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=mb(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length};function Sb(a){return r.isWindow(a)?a:9===a.nodeType&&a.defaultView}r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),d.width||d.height?(e=f.ownerDocument,c=Sb(e),b=e.documentElement,{top:d.top+c.pageYOffset-b.clientTop,left:d.left+c.pageXOffset-b.clientLeft}):d):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),r.nodeName(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||qa})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return S(this,function(a,d,e){var f=Sb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Oa(o.pixelPosition,function(a,c){if(c)return c=Na(a,b),La.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return S(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.parseJSON=JSON.parse,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Tb=a.jQuery,Ub=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Ub),b&&a.jQuery===r&&(a.jQuery=Tb),r},b||(a.jQuery=a.$=r),r});

/*----------------------------------------
 * objectFitPolyfill 2.0.3
 *
 * Made by Constance Chen
 * Released under the MIT license
 *
 * https://github.com/constancecchen/object-fit-polyfill
 *--------------------------------------*/

(function(){
  "use strict";

  // If the browser does support object-fit, we don't need to continue
  if ("objectFit" in document.documentElement.style !== false) {
    window.objectFitPolyfill = function() { return false };
    return;
  }

  /**
   * Check the container's parent element to make sure it will
   * correctly handle and clip absolutely positioned children
   *
   * @param {node} $container - parent element
   */
  var checkParentContainer = function($container) {
    var styles = window.getComputedStyle($container, null);
    var position = styles.getPropertyValue("position");
    var overflow = styles.getPropertyValue("overflow");
    var display = styles.getPropertyValue("display");

    if (!position || position === "static") {
      $container.style.position = "relative";
    }
    if (overflow !== "hidden") {
      $container.style.overflow = "hidden";
    }
    // Guesstimating that people want the parent to act like full width/height wrapper here.
    // Mostly attempts to target <picture> elements, which default to inline.
    if (!display || display === "inline") {
      $container.style.display = "block";
    }
    if ($container.clientHeight === 0) {
      $container.style.height = "100%";
    }

    // Add a CSS class hook, in case people need to override styles for any reason.
    if ($container.className.indexOf("object-fit-polyfill") === -1) {
      $container.className = $container.className + " object-fit-polyfill";
    }
  };

  /**
   * Check for pre-set max-width/height, min-width/height,
   * positioning, or margins, which can mess up image calculations
   *
   * @param {node} $media - img/video element
   */
  var checkMediaProperties = function($media) {
    var styles = window.getComputedStyle($media, null);
    var constraints = {
      "max-width":  "none",
      "max-height": "none",
      "min-width":  "0px",
      "min-height": "0px",
      "top": "auto",
      "right": "auto",
      "bottom": "auto",
      "left": "auto",
      "margin-top": "0px",
      "margin-right": "0px",
      "margin-bottom": "0px",
      "margin-left": "0px",
    };

    for (var property in constraints) {
      var constraint = styles.getPropertyValue(property);

      if (constraint !== constraints[property]) {
        $media.style[property] = constraints[property];
      }
    }
  };

  /**
   * Calculate & set object-position
   *
   * @param {string} axis - either "x" or "y"
   * @param {node} $media - img or video element
   * @param {string} objectPosition - e.g. "50% 50%", "top bottom"
   */
  var setPosition = function(axis, $media, objectPosition) {
    var position, other, start, end, side;
    objectPosition = objectPosition.split(" ");

    if (objectPosition.length < 2) {
      objectPosition[1] = objectPosition[0];
    }

    if (axis === "x") {
      position = objectPosition[0];
      other = objectPosition[1];
      start = "left";
      end = "right";
      side = $media.clientWidth;
    }
    else if (axis === "y") {
      position = objectPosition[1];
      other = objectPosition[0];
      start = "top";
      end = "bottom";
      side = $media.clientHeight;
    }
    else {
      return; // Neither x or y axis specified
    }

    if (position === start || other === start) {
      $media.style[start] = "0";
      return;
    }

    if (position === end || other === end) {
      $media.style[end] = "0";
      return;
    }

    if (position === "center" || position === "50%") {
      $media.style[start] = "50%";
      $media.style["margin-" + start] = (side / -2) + "px";
      return;
    }

    // Percentage values (e.g., 30% 10%)
    if (position.indexOf("%") >= 0) {
      position = parseInt(position);

      if (position < 50) {
        $media.style[start] = position + "%";
        $media.style["margin-" + start] = side * (position / -100) + "px";
      }
      else {
        position = 100 - position;
        $media.style[end] = position + "%";
        $media.style["margin-" + end] = side * (position / -100) + "px";
      }

      return;
    }
    // Length-based values (e.g. 10px / 10em)
    else {
      $media.style[start] = position;
    }

  };

  /**
   * Calculate & set object-fit
   *
   * @param {node} $media - img/video/picture element
   */
  var objectFit = function($media) {
    // Fallbacks, IE 10- data
    var fit = ($media.dataset) ? $media.dataset.objectFit : $media.getAttribute("data-object-fit");
    var position = ($media.dataset) ? $media.dataset.objectPosition : $media.getAttribute("data-object-position");
    fit = fit || "cover";
    position = position || "50% 50%";

    // If necessary, make the parent container work with absolutely positioned elements
    var $container = $media.parentNode;
    checkParentContainer($container);

    // Check for any pre-set CSS which could mess up image calculations
    checkMediaProperties($media);

    // Mathematically figure out which side needs covering, and add CSS positioning & centering
    $media.style.position = "absolute";
    $media.style.height = "100%";
    $media.style.width = "auto";

    if (fit === "scale-down") {
      $media.style.height = "auto";

      if (
        $media.clientWidth < $container.clientWidth &&
        $media.clientHeight < $container.clientHeight
      ) {
        setPosition("x", $media, position);
        setPosition("y", $media, position);
      }
      else {
        fit = "contain";
        $media.style.height = "100%";
      }
    }

    if (fit === "none") {
      $media.style.width = "auto";
      $media.style.height = "auto";
      setPosition("x", $media, position);
      setPosition("y", $media, position);
    }
    else if (
      fit === "cover"   && $media.clientWidth > $container.clientWidth ||
      fit === "contain" && $media.clientWidth < $container.clientWidth
    ) {
      $media.style.top = "0";
      $media.style.marginTop = "0";
      setPosition("x", $media, position);
    }
    else if (fit !== "scale-down") {
      $media.style.width = "100%";
      $media.style.height = "auto";
      $media.style.left = "0";
      $media.style.marginLeft = "0";
      setPosition("y", $media, position);
    }
  };

  /**
   * Initialize plugin
   *
   * @param {node} media - Optional specific DOM node(s) to be polyfilled
   */
  var objectFitPolyfill = function(media) {
    if (typeof media === "undefined") {
      // If left blank, all media on the page will be polyfilled.
      media = document.querySelectorAll("[data-object-fit]");
    } else if (media && media.nodeName) {
      // If it's a single node, wrap it in an array so it works.
      media = [media];
    } else if (typeof media === "object" && media.length && media[0].nodeName) {
      // If it's an array of DOM nodes (e.g. a jQuery selector), it's fine as-is.
      media = media;
    } else {
      // Otherwise, if it's invalid or an incorrect type, return false to let people know.
      return false;
    }

    for (var i = 0; i < media.length; i++) {
      if (!media[i].nodeName) { continue; }

      var mediaType = media[i].nodeName.toLowerCase();

      if (mediaType === "img") {
        if (media[i].complete) {
          objectFit(media[i]);
        }
        else {
          media[i].addEventListener("load", function() {
            objectFit(this);
          });
        }
      }
      else if (mediaType === "video") {
        if (media[i].readyState > 0) {
          objectFit(media[i]);
        }
        else {
          media[i].addEventListener("loadedmetadata", function() {
            objectFit(this);
          });
        }
      }
    }

    return true;
  };

  document.addEventListener("DOMContentLoaded", function() {
    objectFitPolyfill();
  });
  window.addEventListener("resize", function() {
    objectFitPolyfill();
  });

  window.objectFitPolyfill = objectFitPolyfill;

})();
/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */

/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (jQuery && !jQuery.fn.hoverIntent) {
        factory(jQuery);
    }
})(function($) {
    'use strict';

    // default configuration values
    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var cX, cY;

    // saves the current pointer position coordinates based on the given mousemove event
    var track = function(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };

    // compares current and previous mouse positions
    var compare = function(ev,$el,s,cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if ( Math.sqrt( (s.pX-cX)*(s.pX-cX) + (s.pY-cY)*(s.pY-cY) ) < cfg.sensitivity ) {
            $el.off(s.event,track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (permits `out` handler to trigger)
            s.isActive = true;
            // overwrite old mouseenter event coordinates with most recent pointer position
            ev.pageX = cX; ev.pageY = cY;
            // clear coordinate data from state object
            delete s.pX; delete s.pY;
            return cfg.over.apply($el[0],[ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX; s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout( function(){compare(ev, $el, s, cfg);} , cfg.interval );
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function(ev,$el,s,out) {
        delete $el.data('hoverIntent')[s.id];
        return out.apply($el[0],[ev]);
    };

    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ( $.isPlainObject(handlerIn) ) {
            cfg = $.extend(cfg, handlerIn);
            if ( !$.isFunction(cfg.out) ) {
                cfg.out = cfg.over;
            }
        } else if ( $.isFunction(handlerOut) ) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({},e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) { $el.data('hoverIntent', (hoverIntentData = {})); }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) { hoverIntentData[instanceId] = state = { id: instanceId }; }

            // state properties:
            // id = instance ID, used to clean up data
            // timeoutId = timeout ID, reused for tracking mouse position and delaying "out" handler
            // isActive = plugin state, true after `over` is called just until `out` is called
            // pX, pY = previously-measured pointer coordinates, updated at each polling interval
            // event = string representing the namespaced event used for mouse tracking

            // clear any existing timeout
            if (state.timeoutId) { state.timeoutId = clearTimeout(state.timeoutId); }

            // namespaced event used to register and unregister mousemove tracking
            var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent'+instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) { return; }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX; state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.off(mousemove,track).on(mousemove,track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout( function(){compare(ev,$el,state,cfg);} , cfg.interval );
            } else { // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) { return; }
                // unbind expensive mousemove event
                $el.off(mousemove,track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout( function(){delay(ev,$el,state,cfg.out);} , cfg.timeout );
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
});
/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

  $.fn.unveil = function(threshold, callback) {

    var $w = $(window),
        th = threshold || 0,
        retina = window.devicePixelRatio > 1,
        attrib = retina? "data-src-retina" : "data-src",
        images = this,
        loaded;

    this.one("unveil", function() {
      var source = this.getAttribute(attrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        this.setAttribute("src", source);
        if (typeof callback === "function") callback.call(this);
      }
    });

    function unveil() {
      var inview = images.filter(function() {
        var $e = $(this);
        if ($e.is(":hidden")) return;

        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();

        return eb >= wt - th && et <= wb + th;
      });

      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

    unveil();

    return this;

  };

})(window.jQuery || window.Zepto);
/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS
    factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  var pluses = /\+/g;

  function encode(s) {
    return config.raw ? s : encodeURIComponent(s);
  }

  function decode(s) {
    return config.raw ? s : decodeURIComponent(s);
  }

  function stringifyCookieValue(value) {
    return encode(config.json ? JSON.stringify(value) : String(value));
  }

  function parseCookieValue(s) {
    if (s.indexOf('"') === 0) {
      // This is a quoted cookie as according to RFC2068, unescape...
      s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {
      // Replace server-side written pluses with spaces.
      // If we can't decode the cookie, ignore it, it's unusable.
      // If we can't parse the cookie, ignore it, it's unusable.
      s = decodeURIComponent(s.replace(pluses, ' '));
      return config.json ? JSON.parse(s) : s;
    } catch(e) {}
  }

  function read(s, converter) {
    var value = config.raw ? s : parseCookieValue(s);
    return $.isFunction(converter) ? converter(value) : value;
  }

  var config = $.cookie = function (key, value, options) {

    // Write

    if (arguments.length > 1 && !$.isFunction(value)) {
      options = $.extend({}, config.defaults, options);

      if (typeof options.expires === 'number') {
        var days = options.expires, t = options.expires = new Date();
        t.setTime(+t + days * 864e+5);
      }

      return (document.cookie = [
        encode(key), '=', stringifyCookieValue(value),
        options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
        options.path    ? '; path=' + options.path : '',
        options.domain  ? '; domain=' + options.domain : '',
        options.secure  ? '; secure' : ''
      ].join(''));
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling $.cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i++) {
      var parts = cookies[i].split('=');
      var name = decode(parts.shift());
      var cookie = parts.join('=');

      if (key && key === name) {
        // If second argument (value) is a function it's a converter...
        result = read(cookie, value);
        break;
      }

      // Prevent storing a cookie that we couldn't decode.
      if (!key && (cookie = read(cookie)) !== undefined) {
        result[name] = cookie;
      }
    }

    return result;
  };

  config.defaults = {};

  $.removeCookie = function (key, options) {
    if ($.cookie(key) === undefined) {
      return false;
    }

    // Must not alter options, thus extending a fresh object...
    $.cookie(key, '', $.extend({}, options, { expires: -1 }));
    return !$.cookie(key);
  };

}));
window.whatInput = (function() {

  'use strict';

  /*
    ---------------
    variables
    ---------------
  */

  // array of actively pressed keys
  var activeKeys = [];

  // cache document.body
  var body;

  // boolean: true if touch buffer timer is running
  var buffer = false;

  // the last used input type
  var currentInput = null;

  // `input` types that don't accept text
  var nonTypingInputs = [
    'button',
    'checkbox',
    'file',
    'image',
    'radio',
    'reset',
    'submit'
  ];

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  var mouseWheel = detectWheel();

  // list of modifier keys commonly used with the mouse and
  // can be safely ignored to prevent false keyboard detection
  var ignoreMap = [
    16, // shift
    17, // control
    18, // alt
    91, // Windows key / left Apple cmd
    93  // Windows menu / right Apple cmd
  ];

  // mapping of events to input types
  var inputMap = {
    'keydown': 'keyboard',
    'keyup': 'keyboard',
    'mousedown': 'mouse',
    'mousemove': 'mouse',
    'MSPointerDown': 'pointer',
    'MSPointerMove': 'pointer',
    'pointerdown': 'pointer',
    'pointermove': 'pointer',
    'touchstart': 'touch'
  };

  // add correct mouse wheel event mapping to `inputMap`
  inputMap[detectWheel()] = 'mouse';

  // array of all used input types
  var inputTypes = [];

  // mapping of key codes to a common name
  var keyMap = {
    9: 'tab',
    13: 'enter',
    16: 'shift',
    27: 'esc',
    32: 'space',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down'
  };

  // map of IE 10 pointer events
  var pointerMap = {
    2: 'touch',
    3: 'touch', // treat pen like touch
    4: 'mouse'
  };

  // touch buffer timer
  var timer;


  /*
    ---------------
    functions
    ---------------
  */

  // allows events that are also triggered to be filtered out for `touchstart`
  function eventBuffer() {
    clearTimer();
    setInput(event);

    buffer = true;
    timer = window.setTimeout(function() {
      buffer = false;
    }, 650);
  }

  function bufferedEvent(event) {
    if (!buffer) setInput(event);
  }

  function unBufferedEvent(event) {
    clearTimer();
    setInput(event);
  }

  function clearTimer() {
    window.clearTimeout(timer);
  }

  function setInput(event) {
    var eventKey = key(event);
    var value = inputMap[event.type];
    if (value === 'pointer') value = pointerType(event);

    // don't do anything if the value matches the input type already set
    if (currentInput !== value) {
      var eventTarget = target(event);
      var eventTargetNode = eventTarget.nodeName.toLowerCase();
      var eventTargetType = (eventTargetNode === 'input') ? eventTarget.getAttribute('type') : null;

      if (
        (// only if the user flag to allow typing in form fields isn't set
        !body.hasAttribute('data-whatinput-formtyping') &&

        // only if currentInput has a value
        currentInput &&

        // only if the input is `keyboard`
        value === 'keyboard' &&

        // not if the key is `TAB`
        keyMap[eventKey] !== 'tab' &&

        // only if the target is a form input that accepts text
        (
           eventTargetNode === 'textarea' ||
           eventTargetNode === 'select' ||
           (eventTargetNode === 'input' && nonTypingInputs.indexOf(eventTargetType) < 0)
        )) || (
          // ignore modifier keys
          ignoreMap.indexOf(eventKey) > -1
        )
      ) {
        // ignore keyboard typing
      } else {
        switchInput(value);
      }
    }

    if (value === 'keyboard') logKeys(eventKey);
  }

  function switchInput(string) {
    currentInput = string;
    body.setAttribute('data-whatinput', currentInput);

    if (inputTypes.indexOf(currentInput) === -1) inputTypes.push(currentInput);
  }

  function key(event) {
    return (event.keyCode) ? event.keyCode : event.which;
  }

  function target(event) {
    return event.target || event.srcElement;
  }

  function pointerType(event) {
    if (typeof event.pointerType === 'number') {
      return pointerMap[event.pointerType];
    } else {
      return (event.pointerType === 'pen') ? 'touch' : event.pointerType; // treat pen like touch
    }
  }

  // keyboard logging
  function logKeys(eventKey) {
    if (activeKeys.indexOf(keyMap[eventKey]) === -1 && keyMap[eventKey]) activeKeys.push(keyMap[eventKey]);
  }

  function unLogKeys(event) {
    var eventKey = key(event);
    var arrayPos = activeKeys.indexOf(keyMap[eventKey]);

    if (arrayPos !== -1) activeKeys.splice(arrayPos, 1);
  }

  function bindEvents() {
    body = document.body;

    // pointer events (mouse, pen, touch)
    if (window.PointerEvent) {
      body.addEventListener('pointerdown', bufferedEvent);
      body.addEventListener('pointermove', bufferedEvent);
    } else if (window.MSPointerEvent) {
      body.addEventListener('MSPointerDown', bufferedEvent);
      body.addEventListener('MSPointerMove', bufferedEvent);
    } else {

      // mouse events
      body.addEventListener('mousedown', bufferedEvent);
      body.addEventListener('mousemove', bufferedEvent);

      // touch events
      if ('ontouchstart' in window) {
        body.addEventListener('touchstart', eventBuffer);
      }
    }

    // mouse wheel
    body.addEventListener(mouseWheel, bufferedEvent);

    // keyboard events
    body.addEventListener('keydown', unBufferedEvent);
    body.addEventListener('keyup', unBufferedEvent);
    document.addEventListener('keyup', unLogKeys);
  }


  /*
    ---------------
    utilities
    ---------------
  */

  // detect version of mouse wheel event to use
  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  function detectWheel() {
    return mouseWheel = 'onwheel' in document.createElement('div') ?
      'wheel' : // Modern browsers support "wheel"

      document.onmousewheel !== undefined ?
        'mousewheel' : // Webkit and IE support at least "mousewheel"
        'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox
  }


  /*
    ---------------
    init
    don't start script unless browser cuts the mustard,
    also passes if polyfills are used
    ---------------
  */

  if (
    'addEventListener' in window &&
    Array.prototype.indexOf
  ) {

    // if the dom is already ready already (script was placed at bottom of <body>)
    if (document.body) {
      bindEvents();

    // otherwise wait for the dom to load (script was placed in the <head>)
    } else {
      document.addEventListener('DOMContentLoaded', bindEvents);
    }
  }


  /*
    ---------------
    api
    ---------------
  */

  return {

    // returns string: the current input type
    ask: function() { return currentInput; },

    // returns array: currently pressed keys
    keys: function() { return activeKeys; },

    // returns array: all the detected input types
    types: function() { return inputTypes; },

    // accepts string: manually set the input type
    set: switchInput
  };

}());
/*!
Mailchimp Ajax Submit
jQuery Plugin
Author: Siddharth Doshi

Use:
===
$('#form_id').ajaxchimp(options);

- Form should have one <input> element with attribute 'type=email'
- Form should have one label element with attribute 'for=email_input_id' (used to display error/success message)
- All options are optional.

Options:
=======
options = {
    language: 'en',
    callback: callbackFunction,
    url: 'http://blahblah.us1.list-manage.com/subscribe/post?u=5afsdhfuhdsiufdba6f8802&id=4djhfdsh99f'
}

Notes:
=====
To get the mailchimp JSONP url (undocumented), change 'post?' to 'post-json?' and add '&c=?' to the end.
For e.g. 'http://blahblah.us1.list-manage.com/subscribe/post-json?u=5afsdhfuhdsiufdba6f8802&id=4djhfdsh99f&c=?',
*/

(function ($) {
    'use strict';

    $.ajaxChimp = {
        responses: {
            'Thank you for subscribing'                                          				: 0,
            'Please enter a value'                                                              : 1,
            'An email address must contain a single @'                                          : 2,
            'The domain portion of the email address is invalid (the portion after the @: )'    : 3,
            'The username portion of the email address is invalid (the portion before the @: )' : 4,
            'This email address looks fake or invalid. Please enter a real email address'       : 5
        },
        translations: {
            'en': null
        },
        init: function (selector, options) {
            $(selector).ajaxChimp(options);
        }
    };

    $.fn.ajaxChimp = function (options) {
        $(this).each(function(i, elem) {
            var form = $(elem);
            var email = form.find('input[type=email]');
            var label = form.find('label[for=' + email.attr('id') + ']');

            var settings = $.extend({
                'url': form.attr('action'),
                'language': 'en'
            }, options);

            var url = settings.url.replace('/post?', '/post-json?').concat('&c=?');

            form.attr('novalidate', 'true');
            email.attr('name', 'EMAIL');

            form.submit(function () {
                var msg;
                function successCallback(resp) {
                    if (resp.result === 'success') {
                        msg = 'Thank you for subscribing';
                        label.removeClass('error').addClass('valid');
                        email.removeClass('error').addClass('valid');
                    } else {
                        email.removeClass('valid').addClass('error');
                        label.removeClass('valid').addClass('error');
                        var index = -1;
                        try {
                            var parts = resp.msg.split(' - ', 2);
                            if (parts[1] === undefined) {
                                msg = resp.msg;
                            } else {
                                var i = parseInt(parts[0], 10);
                                if (i.toString() === parts[0]) {
                                    index = parts[0];
                                    msg = parts[1];
                                } else {
                                    index = -1;
                                    msg = resp.msg;
                                }
                            }
                        }
                        catch (e) {
                            index = -1;
                            msg = resp.msg;
                        }
                    }

                    // Translate and display message
                    if (
                        settings.language !== 'en'
                        && $.ajaxChimp.responses[msg] !== undefined
                        && $.ajaxChimp.translations
                        && $.ajaxChimp.translations[settings.language]
                        && $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]
                    ) {
                        msg = $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]];
                    }
                    label.html(msg);

                    label.show(2000);
                    if (settings.callback) {
                        settings.callback(resp);
                    }
                }

                var data = {};
                var dataArray = form.serializeArray();
                $.each(dataArray, function (index, item) {
                    data[item.name] = item.value;
                });

                $.ajax({
                    url: url,
                    data: data,
                    success: successCallback,
                    dataType: 'jsonp',
                    error: function (resp, text) {
                        console.log('mailchimp ajax submit error: ' + text);
                    }
                });

                // Translate and display submit message
                var submitMsg = 'Submitting...';
                if(
                    settings.language !== 'en'
                    && $.ajaxChimp.translations
                    && $.ajaxChimp.translations[settings.language]
                    && $.ajaxChimp.translations[settings.language]['submit']
                ) {
                    submitMsg = $.ajaxChimp.translations[settings.language]['submit'];
                }
                label.html(submitMsg).show(2000);

                return false;
            });
        });
        return this;
    };
})(jQuery);
/** vim: et:ts=4:sw=4:sts=4
 * @license RequireJS 2.3.2 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, https://github.com/requirejs/requirejs/blob/master/LICENSE
 */
var requirejs,require,define;!function(global,setTimeout){function commentReplace(e,t){return t||""}function isFunction(e){return"[object Function]"===ostring.call(e)}function isArray(e){return"[object Array]"===ostring.call(e)}function each(e,t){if(e){var i;for(i=0;i<e.length&&(!e[i]||!t(e[i],i,e));i+=1);}}function eachReverse(e,t){if(e){var i;for(i=e.length-1;i>-1&&(!e[i]||!t(e[i],i,e));i-=1);}}function hasProp(e,t){return hasOwn.call(e,t)}function getOwn(e,t){return hasProp(e,t)&&e[t]}function eachProp(e,t){var i;for(i in e)if(hasProp(e,i)&&t(e[i],i))break}function mixin(e,t,i,r){return t&&eachProp(t,function(t,n){!i&&hasProp(e,n)||(!r||"object"!=typeof t||!t||isArray(t)||isFunction(t)||t instanceof RegExp?e[n]=t:(e[n]||(e[n]={}),mixin(e[n],t,i,r)))}),e}function bind(e,t){return function(){return t.apply(e,arguments)}}function scripts(){return document.getElementsByTagName("script")}function defaultOnError(e){throw e}function getGlobal(e){if(!e)return e;var t=global;return each(e.split("."),function(e){t=t[e]}),t}function makeError(e,t,i,r){var n=new Error(t+"\nhttp://requirejs.org/docs/errors.html#"+e);return n.requireType=e,n.requireModules=r,i&&(n.originalError=i),n}function newContext(e){function t(e){var t,i;for(t=0;t<e.length;t++)if(i=e[t],"."===i)e.splice(t,1),t-=1;else if(".."===i){if(0===t||1===t&&".."===e[2]||".."===e[t-1])continue;t>0&&(e.splice(t-1,2),t-=2)}}function i(e,i,r){var n,o,a,s,u,c,d,p,f,l,h,m,g=i&&i.split("/"),v=y.map,x=v&&v["*"];if(e&&(e=e.split("/"),d=e.length-1,y.nodeIdCompat&&jsSuffixRegExp.test(e[d])&&(e[d]=e[d].replace(jsSuffixRegExp,"")),"."===e[0].charAt(0)&&g&&(m=g.slice(0,g.length-1),e=m.concat(e)),t(e),e=e.join("/")),r&&v&&(g||x)){a=e.split("/");e:for(s=a.length;s>0;s-=1){if(c=a.slice(0,s).join("/"),g)for(u=g.length;u>0;u-=1)if(o=getOwn(v,g.slice(0,u).join("/")),o&&(o=getOwn(o,c))){p=o,f=s;break e}!l&&x&&getOwn(x,c)&&(l=getOwn(x,c),h=s)}!p&&l&&(p=l,f=h),p&&(a.splice(0,f,p),e=a.join("/"))}return n=getOwn(y.pkgs,e),n?n:e}function r(e){isBrowser&&each(scripts(),function(t){if(t.getAttribute("data-requiremodule")===e&&t.getAttribute("data-requirecontext")===q.contextName)return t.parentNode.removeChild(t),!0})}function n(e){var t=getOwn(y.paths,e);if(t&&isArray(t)&&t.length>1)return t.shift(),q.require.undef(e),q.makeRequire(null,{skipMap:!0})([e]),!0}function o(e){var t,i=e?e.indexOf("!"):-1;return i>-1&&(t=e.substring(0,i),e=e.substring(i+1,e.length)),[t,e]}function a(e,t,r,n){var a,s,u,c,d=null,p=t?t.name:null,f=e,l=!0,h="";return e||(l=!1,e="_@r"+(T+=1)),c=o(e),d=c[0],e=c[1],d&&(d=i(d,p,n),s=getOwn(j,d)),e&&(d?h=s&&s.normalize?s.normalize(e,function(e){return i(e,p,n)}):e.indexOf("!")===-1?i(e,p,n):e:(h=i(e,p,n),c=o(h),d=c[0],h=c[1],r=!0,a=q.nameToUrl(h))),u=!d||s||r?"":"_unnormalized"+(A+=1),{prefix:d,name:h,parentMap:t,unnormalized:!!u,url:a,originalName:f,isDefine:l,id:(d?d+"!"+h:h)+u}}function s(e){var t=e.id,i=getOwn(S,t);return i||(i=S[t]=new q.Module(e)),i}function u(e,t,i){var r=e.id,n=getOwn(S,r);!hasProp(j,r)||n&&!n.defineEmitComplete?(n=s(e),n.error&&"error"===t?i(n.error):n.on(t,i)):"defined"===t&&i(j[r])}function c(e,t){var i=e.requireModules,r=!1;t?t(e):(each(i,function(t){var i=getOwn(S,t);i&&(i.error=e,i.events.error&&(r=!0,i.emit("error",e)))}),r||req.onError(e))}function d(){globalDefQueue.length&&(each(globalDefQueue,function(e){var t=e[0];"string"==typeof t&&(q.defQueueMap[t]=!0),O.push(e)}),globalDefQueue=[])}function p(e){delete S[e],delete k[e]}function f(e,t,i){var r=e.map.id;e.error?e.emit("error",e.error):(t[r]=!0,each(e.depMaps,function(r,n){var o=r.id,a=getOwn(S,o);!a||e.depMatched[n]||i[o]||(getOwn(t,o)?(e.defineDep(n,j[o]),e.check()):f(a,t,i))}),i[r]=!0)}function l(){var e,t,i=1e3*y.waitSeconds,o=i&&q.startTime+i<(new Date).getTime(),a=[],s=[],u=!1,d=!0;if(!x){if(x=!0,eachProp(k,function(e){var i=e.map,c=i.id;if(e.enabled&&(i.isDefine||s.push(e),!e.error))if(!e.inited&&o)n(c)?(t=!0,u=!0):(a.push(c),r(c));else if(!e.inited&&e.fetched&&i.isDefine&&(u=!0,!i.prefix))return d=!1}),o&&a.length)return e=makeError("timeout","Load timeout for modules: "+a,null,a),e.contextName=q.contextName,c(e);d&&each(s,function(e){f(e,{},{})}),o&&!t||!u||!isBrowser&&!isWebWorker||w||(w=setTimeout(function(){w=0,l()},50)),x=!1}}function h(e){hasProp(j,e[0])||s(a(e[0],null,!0)).init(e[1],e[2])}function m(e,t,i,r){e.detachEvent&&!isOpera?r&&e.detachEvent(r,t):e.removeEventListener(i,t,!1)}function g(e){var t=e.currentTarget||e.srcElement;return m(t,q.onScriptLoad,"load","onreadystatechange"),m(t,q.onScriptError,"error"),{node:t,id:t&&t.getAttribute("data-requiremodule")}}function v(){var e;for(d();O.length;){if(e=O.shift(),null===e[0])return c(makeError("mismatch","Mismatched anonymous define() module: "+e[e.length-1]));h(e)}q.defQueueMap={}}var x,b,q,E,w,y={waitSeconds:7,baseUrl:"./",paths:{},bundles:{},pkgs:{},shim:{},config:{}},S={},k={},M={},O=[],j={},P={},R={},T=1,A=1;return E={require:function(e){return e.require?e.require:e.require=q.makeRequire(e.map)},exports:function(e){if(e.usingExports=!0,e.map.isDefine)return e.exports?j[e.map.id]=e.exports:e.exports=j[e.map.id]={}},module:function(e){return e.module?e.module:e.module={id:e.map.id,uri:e.map.url,config:function(){return getOwn(y.config,e.map.id)||{}},exports:e.exports||(e.exports={})}}},b=function(e){this.events=getOwn(M,e.id)||{},this.map=e,this.shim=getOwn(y.shim,e.id),this.depExports=[],this.depMaps=[],this.depMatched=[],this.pluginMaps={},this.depCount=0},b.prototype={init:function(e,t,i,r){r=r||{},this.inited||(this.factory=t,i?this.on("error",i):this.events.error&&(i=bind(this,function(e){this.emit("error",e)})),this.depMaps=e&&e.slice(0),this.errback=i,this.inited=!0,this.ignore=r.ignore,r.enabled||this.enabled?this.enable():this.check())},defineDep:function(e,t){this.depMatched[e]||(this.depMatched[e]=!0,this.depCount-=1,this.depExports[e]=t)},fetch:function(){if(!this.fetched){this.fetched=!0,q.startTime=(new Date).getTime();var e=this.map;return this.shim?void q.makeRequire(this.map,{enableBuildCallback:!0})(this.shim.deps||[],bind(this,function(){return e.prefix?this.callPlugin():this.load()})):e.prefix?this.callPlugin():this.load()}},load:function(){var e=this.map.url;P[e]||(P[e]=!0,q.load(this.map.id,e))},check:function(){if(this.enabled&&!this.enabling){var e,t,i=this.map.id,r=this.depExports,n=this.exports,o=this.factory;if(this.inited){if(this.error)this.emit("error",this.error);else if(!this.defining){if(this.defining=!0,this.depCount<1&&!this.defined){if(isFunction(o)){if(this.events.error&&this.map.isDefine||req.onError!==defaultOnError)try{n=q.execCb(i,o,r,n)}catch(t){e=t}else n=q.execCb(i,o,r,n);if(this.map.isDefine&&void 0===n&&(t=this.module,t?n=t.exports:this.usingExports&&(n=this.exports)),e)return e.requireMap=this.map,e.requireModules=this.map.isDefine?[this.map.id]:null,e.requireType=this.map.isDefine?"define":"require",c(this.error=e)}else n=o;if(this.exports=n,this.map.isDefine&&!this.ignore&&(j[i]=n,req.onResourceLoad)){var a=[];each(this.depMaps,function(e){a.push(e.normalizedMap||e)}),req.onResourceLoad(q,this.map,a)}p(i),this.defined=!0}this.defining=!1,this.defined&&!this.defineEmitted&&(this.defineEmitted=!0,this.emit("defined",this.exports),this.defineEmitComplete=!0)}}else hasProp(q.defQueueMap,i)||this.fetch()}},callPlugin:function(){var e=this.map,t=e.id,r=a(e.prefix);this.depMaps.push(r),u(r,"defined",bind(this,function(r){var n,o,d,f=getOwn(R,this.map.id),l=this.map.name,h=this.map.parentMap?this.map.parentMap.name:null,m=q.makeRequire(e.parentMap,{enableBuildCallback:!0});return this.map.unnormalized?(r.normalize&&(l=r.normalize(l,function(e){return i(e,h,!0)})||""),o=a(e.prefix+"!"+l,this.map.parentMap),u(o,"defined",bind(this,function(e){this.map.normalizedMap=o,this.init([],function(){return e},null,{enabled:!0,ignore:!0})})),d=getOwn(S,o.id),void(d&&(this.depMaps.push(o),this.events.error&&d.on("error",bind(this,function(e){this.emit("error",e)})),d.enable()))):f?(this.map.url=q.nameToUrl(f),void this.load()):(n=bind(this,function(e){this.init([],function(){return e},null,{enabled:!0})}),n.error=bind(this,function(e){this.inited=!0,this.error=e,e.requireModules=[t],eachProp(S,function(e){0===e.map.id.indexOf(t+"_unnormalized")&&p(e.map.id)}),c(e)}),n.fromText=bind(this,function(i,r){var o=e.name,u=a(o),d=useInteractive;r&&(i=r),d&&(useInteractive=!1),s(u),hasProp(y.config,t)&&(y.config[o]=y.config[t]);try{req.exec(i)}catch(e){return c(makeError("fromtexteval","fromText eval for "+t+" failed: "+e,e,[t]))}d&&(useInteractive=!0),this.depMaps.push(u),q.completeLoad(o),m([o],n)}),void r.load(e.name,m,n,y))})),q.enable(r,this),this.pluginMaps[r.id]=r},enable:function(){k[this.map.id]=this,this.enabled=!0,this.enabling=!0,each(this.depMaps,bind(this,function(e,t){var i,r,n;if("string"==typeof e){if(e=a(e,this.map.isDefine?this.map:this.map.parentMap,!1,!this.skipMap),this.depMaps[t]=e,n=getOwn(E,e.id))return void(this.depExports[t]=n(this));this.depCount+=1,u(e,"defined",bind(this,function(e){this.undefed||(this.defineDep(t,e),this.check())})),this.errback?u(e,"error",bind(this,this.errback)):this.events.error&&u(e,"error",bind(this,function(e){this.emit("error",e)}))}i=e.id,r=S[i],hasProp(E,i)||!r||r.enabled||q.enable(e,this)})),eachProp(this.pluginMaps,bind(this,function(e){var t=getOwn(S,e.id);t&&!t.enabled&&q.enable(e,this)})),this.enabling=!1,this.check()},on:function(e,t){var i=this.events[e];i||(i=this.events[e]=[]),i.push(t)},emit:function(e,t){each(this.events[e],function(e){e(t)}),"error"===e&&delete this.events[e]}},q={config:y,contextName:e,registry:S,defined:j,urlFetched:P,defQueue:O,defQueueMap:{},Module:b,makeModuleMap:a,nextTick:req.nextTick,onError:c,configure:function(e){if(e.baseUrl&&"/"!==e.baseUrl.charAt(e.baseUrl.length-1)&&(e.baseUrl+="/"),"string"==typeof e.urlArgs){var t=e.urlArgs;e.urlArgs=function(e,i){return(i.indexOf("?")===-1?"?":"&")+t}}var i=y.shim,r={paths:!0,bundles:!0,config:!0,map:!0};eachProp(e,function(e,t){r[t]?(y[t]||(y[t]={}),mixin(y[t],e,!0,!0)):y[t]=e}),e.bundles&&eachProp(e.bundles,function(e,t){each(e,function(e){e!==t&&(R[e]=t)})}),e.shim&&(eachProp(e.shim,function(e,t){isArray(e)&&(e={deps:e}),!e.exports&&!e.init||e.exportsFn||(e.exportsFn=q.makeShimExports(e)),i[t]=e}),y.shim=i),e.packages&&each(e.packages,function(e){var t,i;e="string"==typeof e?{name:e}:e,i=e.name,t=e.location,t&&(y.paths[i]=e.location),y.pkgs[i]=e.name+"/"+(e.main||"main").replace(currDirRegExp,"").replace(jsSuffixRegExp,"")}),eachProp(S,function(e,t){e.inited||e.map.unnormalized||(e.map=a(t,null,!0))}),(e.deps||e.callback)&&q.require(e.deps||[],e.callback)},makeShimExports:function(e){function t(){var t;return e.init&&(t=e.init.apply(global,arguments)),t||e.exports&&getGlobal(e.exports)}return t},makeRequire:function(t,n){function o(i,r,u){var d,p,f;return n.enableBuildCallback&&r&&isFunction(r)&&(r.__requireJsBuild=!0),"string"==typeof i?isFunction(r)?c(makeError("requireargs","Invalid require call"),u):t&&hasProp(E,i)?E[i](S[t.id]):req.get?req.get(q,i,t,o):(p=a(i,t,!1,!0),d=p.id,hasProp(j,d)?j[d]:c(makeError("notloaded",'Module name "'+d+'" has not been loaded yet for context: '+e+(t?"":". Use require([])")))):(v(),q.nextTick(function(){v(),f=s(a(null,t)),f.skipMap=n.skipMap,f.init(i,r,u,{enabled:!0}),l()}),o)}return n=n||{},mixin(o,{isBrowser:isBrowser,toUrl:function(e){var r,n=e.lastIndexOf("."),o=e.split("/")[0],a="."===o||".."===o;return n!==-1&&(!a||n>1)&&(r=e.substring(n,e.length),e=e.substring(0,n)),q.nameToUrl(i(e,t&&t.id,!0),r,!0)},defined:function(e){return hasProp(j,a(e,t,!1,!0).id)},specified:function(e){return e=a(e,t,!1,!0).id,hasProp(j,e)||hasProp(S,e)}}),t||(o.undef=function(e){d();var i=a(e,t,!0),n=getOwn(S,e);n.undefed=!0,r(e),delete j[e],delete P[i.url],delete M[e],eachReverse(O,function(t,i){t[0]===e&&O.splice(i,1)}),delete q.defQueueMap[e],n&&(n.events.defined&&(M[e]=n.events),p(e))}),o},enable:function(e){var t=getOwn(S,e.id);t&&s(e).enable()},completeLoad:function(e){var t,i,r,o=getOwn(y.shim,e)||{},a=o.exports;for(d();O.length;){if(i=O.shift(),null===i[0]){if(i[0]=e,t)break;t=!0}else i[0]===e&&(t=!0);h(i)}if(q.defQueueMap={},r=getOwn(S,e),!t&&!hasProp(j,e)&&r&&!r.inited){if(!(!y.enforceDefine||a&&getGlobal(a)))return n(e)?void 0:c(makeError("nodefine","No define call for "+e,null,[e]));h([e,o.deps||[],o.exportsFn])}l()},nameToUrl:function(e,t,i){var r,n,o,a,s,u,c,d=getOwn(y.pkgs,e);if(d&&(e=d),c=getOwn(R,e))return q.nameToUrl(c,t,i);if(req.jsExtRegExp.test(e))s=e+(t||"");else{for(r=y.paths,n=e.split("/"),o=n.length;o>0;o-=1)if(a=n.slice(0,o).join("/"),u=getOwn(r,a)){isArray(u)&&(u=u[0]),n.splice(0,o,u);break}s=n.join("/"),s+=t||(/^data\:|^blob\:|\?/.test(s)||i?"":".js"),s=("/"===s.charAt(0)||s.match(/^[\w\+\.\-]+:/)?"":y.baseUrl)+s}return y.urlArgs&&!/^blob\:/.test(s)?s+y.urlArgs(e,s):s},load:function(e,t){req.load(q,e,t)},execCb:function(e,t,i,r){return t.apply(r,i)},onScriptLoad:function(e){if("load"===e.type||readyRegExp.test((e.currentTarget||e.srcElement).readyState)){interactiveScript=null;var t=g(e);q.completeLoad(t.id)}},onScriptError:function(e){var t=g(e);if(!n(t.id)){var i=[];return eachProp(S,function(e,r){0!==r.indexOf("_@r")&&each(e.depMaps,function(e){if(e.id===t.id)return i.push(r),!0})}),c(makeError("scripterror",'Script error for "'+t.id+(i.length?'", needed by: '+i.join(", "):'"'),e,[t.id]))}}},q.require=q.makeRequire(),q}function getInteractiveScript(){return interactiveScript&&"interactive"===interactiveScript.readyState?interactiveScript:(eachReverse(scripts(),function(e){if("interactive"===e.readyState)return interactiveScript=e}),interactiveScript)}var req,s,head,baseElement,dataMain,src,interactiveScript,currentlyAddingScript,mainScript,subPath,version="2.3.2",commentRegExp=/\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm,cjsRequireRegExp=/[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,jsSuffixRegExp=/\.js$/,currDirRegExp=/^\.\//,op=Object.prototype,ostring=op.toString,hasOwn=op.hasOwnProperty,isBrowser=!("undefined"==typeof window||"undefined"==typeof navigator||!window.document),isWebWorker=!isBrowser&&"undefined"!=typeof importScripts,readyRegExp=isBrowser&&"PLAYSTATION 3"===navigator.platform?/^complete$/:/^(complete|loaded)$/,defContextName="_",isOpera="undefined"!=typeof opera&&"[object Opera]"===opera.toString(),contexts={},cfg={},globalDefQueue=[],useInteractive=!1;if("undefined"==typeof define){if("undefined"!=typeof requirejs){if(isFunction(requirejs))return;cfg=requirejs,requirejs=void 0}"undefined"==typeof require||isFunction(require)||(cfg=require,require=void 0),req=requirejs=function(e,t,i,r){var n,o,a=defContextName;return isArray(e)||"string"==typeof e||(o=e,isArray(t)?(e=t,t=i,i=r):e=[]),o&&o.context&&(a=o.context),n=getOwn(contexts,a),n||(n=contexts[a]=req.s.newContext(a)),o&&n.configure(o),n.require(e,t,i)},req.config=function(e){return req(e)},req.nextTick="undefined"!=typeof setTimeout?function(e){setTimeout(e,4)}:function(e){e()},require||(require=req),req.version=version,req.jsExtRegExp=/^\/|:|\?|\.js$/,req.isBrowser=isBrowser,s=req.s={contexts:contexts,newContext:newContext},req({}),each(["toUrl","undef","defined","specified"],function(e){req[e]=function(){var t=contexts[defContextName];return t.require[e].apply(t,arguments)}}),isBrowser&&(head=s.head=document.getElementsByTagName("head")[0],baseElement=document.getElementsByTagName("base")[0],baseElement&&(head=s.head=baseElement.parentNode)),req.onError=defaultOnError,req.createNode=function(e,t,i){var r=e.xhtml?document.createElementNS("http://www.w3.org/1999/xhtml","html:script"):document.createElement("script");return r.type=e.scriptType||"text/javascript",r.charset="utf-8",r.async=!0,r},req.load=function(e,t,i){var r,n=e&&e.config||{};if(isBrowser)return r=req.createNode(n,t,i),r.setAttribute("data-requirecontext",e.contextName),r.setAttribute("data-requiremodule",t),!r.attachEvent||r.attachEvent.toString&&r.attachEvent.toString().indexOf("[native code")<0||isOpera?(r.addEventListener("load",e.onScriptLoad,!1),r.addEventListener("error",e.onScriptError,!1)):(useInteractive=!0,r.attachEvent("onreadystatechange",e.onScriptLoad)),r.src=i,n.onNodeCreated&&n.onNodeCreated(r,n,t,i),currentlyAddingScript=r,baseElement?head.insertBefore(r,baseElement):head.appendChild(r),currentlyAddingScript=null,r;if(isWebWorker)try{setTimeout(function(){},0),importScripts(i),e.completeLoad(t)}catch(r){e.onError(makeError("importscripts","importScripts failed for "+t+" at "+i,r,[t]))}},isBrowser&&!cfg.skipDataMain&&eachReverse(scripts(),function(e){if(head||(head=e.parentNode),dataMain=e.getAttribute("data-main"))return mainScript=dataMain,cfg.baseUrl||mainScript.indexOf("!")!==-1||(src=mainScript.split("/"),mainScript=src.pop(),subPath=src.length?src.join("/")+"/":"./",cfg.baseUrl=subPath),mainScript=mainScript.replace(jsSuffixRegExp,""),req.jsExtRegExp.test(mainScript)&&(mainScript=dataMain),cfg.deps=cfg.deps?cfg.deps.concat(mainScript):[mainScript],!0}),define=function(e,t,i){var r,n;"string"!=typeof e&&(i=t,t=e,e=null),isArray(t)||(i=t,t=null),!t&&isFunction(i)&&(t=[],i.length&&(i.toString().replace(commentRegExp,commentReplace).replace(cjsRequireRegExp,function(e,i){t.push(i)}),t=(1===i.length?["require"]:["require","exports","module"]).concat(t))),useInteractive&&(r=currentlyAddingScript||getInteractiveScript(),r&&(e||(e=r.getAttribute("data-requiremodule")),n=contexts[r.getAttribute("data-requirecontext")])),n?(n.defQueue.push([e,t,i]),n.defQueueMap[e]=!0):globalDefQueue.push([e,t,i])},define.amd={jQuery:!0},req.exec=function(text){return eval(text)},req(cfg)}}(this,"undefined"==typeof setTimeout?void 0:setTimeout);
/**
 * SDG Custom Functions
 *
 * run
 * run dom ready
 * extend
 * utilities
 * debounce
 * media query
 * lazy load
 * modal
 * accordion
 * sticky
 * size guide
 * variant label
 * flash sale
 * notify
 * custom zendesk
 * incrementer
 * affiliate
 * show quick popup
 * newsletter modal
 * header functions
 * gift box
 * cart vars
 * ajax add to cart
 * product image in nav
 * fire functions
 */

/**
 * SDG namespace
 * @type {Object}
 */
var SDG = SDG || {};
var __ = window.__ || {};

/**
 * util functions
 */

 /**
  * click outside
  * @param  {Object} opts
  * @return {__.clickOutside~init}
  */
 __.clickOutside = function (opts) {
 	var config = {
 		callback: null,
 		condition: null,
 		exclude_selectors: '',
 		selector: ''
 	},
 	    c = __.extend(config, opts),


 	// cached globals
 	excludedElements = [];

 	/**
   * init
   */
 	function init() {
 		addEvents();
 	}

 	/**
   * setup excluded
   */
 	function setupExcluded() {

 		excludedElements = [];

 		var excludedSelectors = [];

 		// if there are no excluded selectors, exit function
 		if (!c.exclude_selectors) return;

 		// if there's a comma, i.e. multiple selectors, create array from list
 		// else push the single item to the array
 		if (c.exclude_selectors.indexOf(',') !== -1) {
 			excludedSelectors = c.exclude_selectors.split(',');
 		} else {
 			excludedSelectors.push(c.exclude_selectors);
 		}

 		// query selectors and push them to array
 		excludedSelectors.forEach(addElementToExcludedArray);
 	}

 	/**
   * add element to excluded array
   * @callback
   * @param {String} selector
   * @param {Number} i
   * @param {Array}  arr
   */
 	function addElementToExcludedArray(selector, i, arr) {
 		var el = document.querySelectorAll(selector),
 		    elCount = el.length,
 		    children = void 0,
 		    childCount = void 0,
 		    itr = void 0,
 		    childItr = void 0;

 		if (el) {
 			for (itr = 0; itr < elCount; itr++) {
 				excludedElements.push(el[itr]);

 				children = el.children;
 				childCount = children ? children.length : null;

 				if (childCount) {
 					for (childItr = 0; childItr < childCount; childItr++) {
 						excludedElements.push(children[childItr]);
 					}
 				}
 			}
 		}
 	}

 	/**
   * is excluded element
   * @callback
   * @param  {Element} el
   * @param  {Number}  i
   * @param  {Array}   arr
   * @return {Boolean}
   */
 	function isExcludedElement(el, i, arr) {
 		return el === this;
 	}

 	/**
   * add events
   */
 	function addEvents() {

 		// document click
 		__.addEvent({
 			id: document,
 			event: 'click',
 			fn: onDocumentClick
 		});
 	}

 	/**
   * on document click
   * @param {Object} e event
   */
 	function onDocumentClick(e) {

 		setupExcluded();

 		var isExElement = excludedElements.some(isExcludedElement, e.target);

 		var isConditionFn = typeof c.condition === 'function',
 		    hasMetConditions = isExElement ? isConditionFn && !isExElement : isConditionFn && c.condition(),
 		    hasClickedOutside = void 0;

 		// if conditions have not been met, exit function
 		if (!hasMetConditions) return;

 		// traverse up dom to see if user clicked within selector
 		hasClickedOutside = !__.parents(e.target, c.selector);

 		// if clicked outside, fire callback
 		if (typeof c.callback === 'function' && hasClickedOutside) c.callback();
 	}

 	/**
   * return
   * @type {Object}
   */
 	return {
 		init: init()
 	};
 };

 /**
  * add class
  * @param {string} el
  * @param {string} className
  */
 __.addClass = function (el, className) {

 	if (!__.hasClass(el, className)) {
 		if (el.classList) {
 			el.classList.add(className);
 		} else {
 			el.className += ' ' + className;
 		}
 	}
 };

 /**
  * remove class
  * @param {element} el
  * @param {string} className
  */
 __.removeClass = function (el, className) {
 	if (__.hasClass(el, className)) {
 		if (el.classList) {
 			el.classList.remove(className);
 		} else {
 			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
 		}
 	}
 };

 /**
 * has class
 * @param  {element}  el
 * @param  {string}  className
 * @return {boolean}
 */
__.hasClass = function (el, className) {
	if (el.classList) {
		return el.classList.contains(className);
	} else {
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	}
};

 /**
  * is delineated array
  * @param  {*}       data any type
  * @return {boolean}
  */
 __.isDelimitedArray = function (str, delimiter) {
 	if (!str) {
 		console.warn('No string defined');
 		return false;
 	}

 	if (!delimiter) {
 		delimiter = ',';
 	}

 	return str.indexOf(delimiter) !== -1 ? true : false;
 };
 /**
  * trigger event
  * @param  {object} el - Element that event is being triggered on.
  * Must pass selected dom element, not just a string.
  * @param  {string} eventName - Name of custom event that needs to be trigger.
  * @param  {boolean} bubbles - A Boolean indicating whether the event bubbles up
  * through the DOM or not. Default: true
  * @param  {boolean} cancelable - A Boolean indicating whether the event is cancelable.
  * Default: true
  * @return {function} - Dispatches the custom event that's bound to the element.
  */
 __.trigger = function (el, eventName) {
 	var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
 	var bubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
 	var cancelable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

 	if (el === undefined || eventName === undefined) return false;

 	var event = new CustomEvent(eventName, {
 		detail: {
 			el: el,
 			time: new Date(),
 			obj: obj
 		},
 		bubbles: bubbles,
 		cancelable: cancelable
 	});

 	el.dispatchEvent(event);

 	return undefined;
 };

 /**
  * is object
  * @param  {*}       data any type
  * @return {boolean}
  */
 __.isObject = function (data) {
   return Object.prototype.toString.call(data) === '[object Object]';
 };

 /**
  * extend
  * extends a js object
  * @param  {Object} config
  * @param  {Object} obj
  * @return {Object}
  */
 __.extend = function (config, obj) {
 	obj = obj || {};

 	Object.keys(config).forEach(function (key) {
 		if (obj[key] === undefined) {
 			obj[key] = config[key];
 		} else {
 			if (obj[key] && __.isObject(obj[key]) && __.isObject(config[key])) {
 				Object.keys(config[key]).forEach(function (childKey) {
 					if (obj[key][childKey] === undefined) {
 						obj[key][childKey] = config[key][childKey];
 					}
 				});
 			}
 		}
 	});

 	return obj;
 };

 /**
  * Dom Event
  * @type {function}
  * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent t he parent object's id.
  * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
  * @param {object | string} object.event - Event which triggers the function.
  * @param {object.function} object.fn - Function to bind to each element.
  * @param {boolean} - applyEvent - Dictates whether to addEventListener or removeEventListener
  */
 __.domEvent = function (opts, applyE) {
 	var c = opts,
 	    eApply = applyE !== undefined ? applyE : true,
 	    $id = void 0,
 	    $class = void 0,
 	    isString = void 0,
 	    hasIds = void 0,
 	    hasEvents = void 0,
 	    $trigger = void 0,
 	    i = void 0,
 	    idArr = void 0,
 	    eventArr = void 0;

 	/**
   * init
   * @return {function} Checks if c.id, c.fn, and c.event are defined. If not add event is skipped. This also maps the letiables for $id and domClass
   */
 	function init() {
 		if (c.id) {
 			// Is c.id set?

 			if (c.fn || c.event) {
 				// If c.fn and c.event are set then execute functions.

 				checkForArray();

 				if (hasIds) {
 					idArr = c.id.split(',');

 					for (i = 0; i < idArr.length; i++) {
 						c.id = idArr[i];
 						bindEvents();
 					}
 				} else {
 					bindEvents();
 				}
 			} else {
 				if (c.fn === null) {
 					// Check if c.fn is set, if not warn the developer.
 					console.warn('No function defined.');
 				}
 				if (c.event === null) {
 					// Check if c.event is set, if not warn the developer.
 					console.warn('No event defined.');
 				}
 			}
 		} else {
 			// if c.id is not set, then warn the developer.
 			console.warn('No ID defined.');
 		}
 	}

 	/**
   * check for array
   */
 	function checkForArray() {
 		isString = typeof c.id === 'string' ? true : false;

 		if (isString) {
 			hasIds = __.isDelimitedArray(c.id);
 		}

 		hasEvents = __.isDelimitedArray(c.event);
 	}

 	/**
   * bind events
   * @type {Function}
   */
 	function bindEvents() {

 		maplets(); // Map vas called inside c.fn and c.event check to avoid unnecessary DOM search.

 		if (c.className) {
 			bindLoop(); // If a class value was set, bind the event to dom elements within a parent id.
 		} else {
 			bindSingle(); // If only an id was set and no className, then bind the event to a single id.
 		}
 	}

 	/**
   * map lets
   * @return {function} Sets domId letiable and if c.className exists, sets domClass value.
   */
 	function maplets() {

 		if (isString) {
 			$id = document.getElementById(c.id);
 		} else {
 			$id = c.id;
 		}

 		if ($id) {
 			if (c.className === null) {
 				$class = null;
 			} else {
 				$class = $id.querySelectorAll('.' + c.className);
 			}
 		} else {
 			if (isString) {
 				console.warn('Could not find id ' + c.id);
 			} else {
 				console.warn('Could not find element.');
 			}
 		}
 	}

 	/**
   * bind loop
   * @return {function} Bind events to dom elements within the defined c.id dom element.
   */
 	function bindLoop() {
 		if ($class) {
 			for (i = 0; i < $class.length; i++) {
 				$trigger = $class[i];

 				if ($trigger) {

 					if (eApply) {
 						if (hasEvents) {

 							eventArr = c.event.split(',');

 							for (i = 0; i < eventArr.length; i++) {
 								$trigger.addEventListener(eventArr[i], c.fn, null);
 							}
 						} else {
 							$trigger.addEventListener(c.event, c.fn, null);
 						}
 					} else {
 						$trigger.removeEventListener(c.event, c.fn, null);
 					}
 				}
 			}
 		}
 	}

 	/**
   * bind single
   * @return {function} Add event listener to a single dom element based on id.
   */
 	function bindSingle() {
 		if ($id) {

 			if (eApply) {
 				if (hasEvents) {
 					eventArr = c.event.split(',');

 					for (i = 0; i < eventArr.length; i++) {
 						$id.addEventListener(eventArr[i], c.fn, false);
 					}
 				} else {
 					$id.addEventListener(c.event, c.fn, false);
 				}
 			} else {
 				$id.removeEventListener(c.event, c.fn, false);
 			}
 		}
 	}

 	return init();
 };

 /**
  * Add Event
  * @type {function}
  * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
  * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
  * @param {object | string} object.event - Event which triggers the function.
  * @param {object.function} object.fn - Function to bind to each element.
  */
 __.addEvent = function (opts) {
 	if (opts === undefined) {
 		console.warn('__.addEvent requires a config object.');
 	} else {
 		__.domEvent(opts, true);
 	}
 };

 /**
  * Remove Event
  * @type {function}
  * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
  * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
  * @param {object | string} object.event - Event which triggers the function.
  * @param {object.function} object.fn - Function to bind to each element.
  */
 __.removeEvent = function (opts) {
 	if (opts === undefined) {
 		console.warn('__.removeEvent requires a config object.');
 	} else {
 		__.domEvent(opts, false);
 	}
 };

 /**
 * is parent
 * @param  {Node} elem
 * @param  {String} selector
 * @return {Node}
 */
__.parents = function (elem, selector) {
	var parents = [];
	var firstChar = void 0;
	if (selector) {
		firstChar = selector.charAt(0);
	}

	// Get matches
	for (; elem && elem !== document; elem = elem.parentNode) {
		if (selector) {

			// If selector is a class
			if (firstChar === '.') {
				if (elem.classList.contains(selector.substr(1))) {
					parents.push(elem);
				}
			}

			// If selector is an ID
			if (firstChar === '#') {
				if (elem.id === selector.substr(1)) {
					parents.push(elem);
				}
			}

			// If selector is a data attribute
			if (firstChar === '[') {
				if (elem.hasAttribute(selector.substr(1, selector.length - 1))) {
					parents.push(elem);
				}
			}

			// If selector is a tag
			if (elem.tagName.toLowerCase() === selector) {
				parents.push(elem);
			}
		} else {
			parents.push(elem);
		}
	}

	// Return parents if any exist
	if (parents.length === 0) {
		return null;
	} else {
		return parents;
	}
};

/**
 * run
 * @type {Function}
 */
SDG.run = function() {

	// prevent iOS safari back button cache
	window.onpageshow = function(event) {
		if (event.persisted) {
			window.location.reload();
		}
	};
};

/**
 * run dom ready
 * @type {Function}
 */
SDG.runDomReady = function() {

	var modalSizeGuide = SDG.modal({
			obj: '#modalSizeguide',
			autoshow: false,
			close_from_outside: false,
		}),
		modalProductZoom = SDG.modal({
			obj: '#productZoom',
			autoshow: false,
			close_from_outside: false,
		}),
		modalDonation = SDG.modal({
			obj: '#modalDonation',
			close_from_outside: true,
			exclude_selectors_from_parent: '#zoomImg',
		}),
		incrementer = SDG.incrementer(),
		footerPrefValue = '';

	// init functions
	// mq.init();
	modalSizeGuide.init();
	modalProductZoom.init();
	incrementer.init();
	headerFunctions.init();
	newsletterModal();
	modalDonation.init();

	$('#footer_email_signup').on('click','.js-checkbox',function() {
		var val = $(this).val();
		if ($(this).is(':checked')) {
			footerPrefValue += val+',';
		} else {
			footerPrefValue = footerPrefValue.replace(val+',','');
		}
		$('#footerPreference').val(footerPrefValue.slice(0, -1));
	});

	$('#footerSignupBtn').on('click', function(e) {

		gtag_report_conversion();

		if ($('#footerInput').val() !== '' && SDG.validateEmail($('#footerInput').val())) {

			if ($('#footerPrefMens').is(':checked') && $('#footerPrefWomens').is(':checked')) {
				footerPrefValue = $('#footerPrefMens').val()+','+$('#footerPrefWomens').val();
			} else if ($('#footerPrefMens').is(':checked')) {
				footerPrefValue = $('#footerPrefMens').val();
			} else if ($('#footerPrefWomens').is(':checked')) {
				footerPrefValue = $('#footerPrefWomens').val();
			} else {
				footerPrefValue = '';
			}
			$('#footerPreference').val(footerPrefValue);

			if ($('#footerPrefMens').is(':checked') || $('#footerPrefWomens').is(':checked')) {
				return true;
			} else {
				$('#footer_email_signup .klaviyo_messages .error_message').empty();
				$('#footer_email_signup .klaviyo_messages .error_message').html('PLEASE SELECT YOUR PREFERENCE').show();

				e.preventDefault();
				return false;
			}

		} else {
			$('#footer_email_signup .klaviyo_messages .error_message').empty();
			$('#footer_email_signup .klaviyo_messages .error_message').html('PLEASE ENTER VALID EMAIL').show();

			e.preventDefault();
			return false;
		}
	});


	KlaviyoSubscribe.attachToForms('#footer_email_signup', {
		hide_form_on_success: false,
		extra_properties: {
			$source: 'NL_footer'
		},
		success: function () {
			$('#footerSignupBtn').addClass('is-success').html('<span class="icons icons--tick"></span>');

			footerPrefValue = '';
			$('#footerPreference').val('');
		}
	});


	// AJAX add to cart
	if (jeSettings.enable_ajax_add) {
		ajaxAddToCart.init();
	}

	SDG.megaMenu();

  SDG.promo();

	// Cart page
	if (Shopify.cart.item_count > 0) {
		$('#cartDonation').removeClass('hide');
	}

	// flickity iOS 13 drag fix
  SDG.dragFix();
};

/**
 * dragFix
 * @return {Object}
 */
SDG.dragFix = function() {
  var touchingCarousel = false;
  var touchStartCoords;

  document.body.addEventListener('touchstart', function(event) {
    if (event.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY,
    };
  });

  document.body.addEventListener('touchmove', function(event) {
    if (!(touchingCarousel && event.cancelable)) {
      return;
    }

    var moveVector = {
      x: event.touches[0].pageX - touchStartCoords.x,
      y: event.touches[0].pageY - touchStartCoords.y,
    };

    if (Math.abs(moveVector.x) > 7) {
      event.preventDefault();
    }

  }, { passive: false });
};

/**
 * extend
 * @param  {Object} config
 * @param  {Object} target
 * @return {Object}
 */
SDG.extend = function(config, target) {
	target = target || {};
	Object.keys(config).forEach(function(key) {
		if (target[key] === undefined) {
			target[key] = config[key];
		}
	});
	return target;
};

/**
 * utilities (vanilla)
 *
 * get url parameter
 * replace
 * is visible
 * has class
 * add class
 * remove class
 *
 * @return {Object}
 */
SDG.util = function() {

	// sub module
	var _ = {};

	/**
	 * get url parameter
	 * @param {string} sParam - parameter name
	 */
	__.getUrlParameter = function(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	/**
	 * replace
	 * @param  {string} string
	 * @param  {string} needle   searched value
	 * @param  {string} newValue new value you wish to replace the needle with
	 * @return {string}
	 */
	__.replace = function(string, needle, newValue) {
		var newString;

		// if string contains needle, return new value
		if (string.indexOf(needle) !== -1) {
			newString = string.replace(needle, newValue);
		}

		// else return string as-is if needle could not be found
		else {
			newString = string;
		}

		return newString;
	};

	/**
	 * is visible
	 * @param  {Element} el
	 * @return {Boolean}
	 */
	__.isVisible = function(el) {
		return el.offsetParent !== null;
	};

	/**
	 * has class
	 * @param  {string}  el
	 * @param  {string}  className
	 * @return {Boolean}
	 */
	__.hasClass = function(el, className) {
		if (el.classList) {
			return el.classList.contains(className);
		}
		else {
			return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
		}
	};

	/**
	 * add class
	 * @param {string} el
	 * @param {string} className
	 */
	__.addClass = function(el, className) {
		if (! __.hasClass(el, className)) {
			if (el.classList) {
				el.classList.add(className);
			}
			else {
				el.className += ' ' + className;
			}
		}
	};

	/**
	 * remove class
	 * @param {string} el
	 * @param {string} className
	 */
	__.removeClass = function(el, className) {
		if (__.hasClass(el, className)) {
			if (el.classList) {
				el.classList.remove(className);
			}
			else {
				el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		}
	};

	return _;
};

/**
 * debounce
 * @param {function} func      name of function
 * @param {number}   threshold timeout delay
 * @param {boolean}  execAsap  execute immediately?
 * @type  {Function}
 */
SDG.debounce = function(func, threshold, execAsap) {
	var timeout;

	return function debounced() {
		var obj = this,
			args = arguments;

		function delayed() {
			if (!execAsap) {
				func.apply(obj, args);
			}
			timeout = null;
		}

		if (timeout) {
			clearTimeout(timeout);
		}
		else if (execAsap) {
			func.apply(obj, args);
		}

		timeout = setTimeout(delayed, threshold || 100);
	};
};

/**
 * media query
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.mq = function(opts) {
	var config = {
			view: null,
			callback: null,
			views: {
				smaller_phone: '(max-width:413px)',
				small_phone: '(max-width:479px)',
				phone: '(max-width:767px)',
				large_phone: '(min-width: 414px) and (max-width: 767px)',
				larger_phone: '(min-width: 480px) and (max-width: 767px)',
				mobile: '(max-width:1024px)',
				tablet: '(min-width:768px)',
				tablet_only: '(min-width:768px) and (max-width:1024px)',
				tablet_portrait: '(min-width:768px) and (max-width:979px)',
				tablet_landscape: '(min-width:980px) and (max-width:1024px)',
				desktop: '(min-width:1025px)',
				desktop_large: '(min-width:1281px)',
				desktop_huge: '(min-width:1401px)'
			}
		},
		c = SDG.extend(config, opts);

	/**
	 * init
	 */
	function init() {

		if (c.view) {

			var currentView = null,
				query;

			$.each(c.views, function(key, value) {
				if (key === c.view) {
					currentView = value;
				}
			});

			query = Modernizr.mq(currentView);

			if (query) {
				c.callback();
			}
		}
	}

	return {
		init: init
	};
};

/**
 * lazy load
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.lazyLoad = function(opts) {
	var config = {
			id: null,
			single_selector: 'img.lazy',
			responsive: false,
			responsive_selectors: ['smaller_phone','small_phone','larger_phone', 'phone', 'mobile', 'tablet', 'tablet_only', 'desktop'],
			threshhold: 600,
			responsive_refresh: 500,
			loaded: 'loaded',
			loading: 'loading',
			loadCallBack: null,
			triggerOnLoad: false
		},
		c = SDG.extend(config, opts),
		unveiled = [];

	/**
	 * init
	 */
	function init() {
		if (c.responsive === true) {
			runUnveil(c.single_selector);
			responsiveInit();
			responsiveResize();
		} else {
			runUnveil(c.single_selector);
			if (c.triggerOnLoad === true) {
				triggerOnLoad(c.single_selector);
			}
		}
	}

	/**
	 * responsive init
	 */
	function responsiveInit() {

		var sizes = c.responsive_selectors,
			sizesArr = $.makeArray(sizes);

		if ($(sizesArr).not(unveiled).length !== 0) {

			$.each(sizes, function(index, value) {
				var size = value,
					sizeClass;

				var mq = SDG.mq({
					view: size,
					callback: function() {
						if ($.inArray(size, unveiled) === -1) {

							sizeClass = size;

							if (size === 'tablet_only') {
								sizeClass = 'tablet';
							}

							if (size === 'small_phone') {
								sizeClass = 'small-phone';
							}

							if (size === 'larger_phone') {
								sizeClass = 'larger-phone';
							}

							if (size === 'tablet') {
								sizeClass = 'desktop-and-tablet';
							}

							runUnveil('.' + sizeClass + '-lazy');

							if (c.triggerOnLoad === true) {
								triggerOnLoad('.' + sizeClass + '-lazy');
							}

							unveiled.push(sizeClass);
						}
					}
				});

				mq.init();
			});
		}
	}

	/**
	 * run unveil
	 * @param {string} or {jQuery} selector string or jQuery object
	 */
	function runUnveil(obj) {
		var unveilObj,
			unveilSelector;

		if (obj instanceof jQuery) {
			unveilObj = obj;
		} else {
			unveilSelector = (c.id !== null ? c.id + ' ' : '') + obj;
			unveilObj = $(unveilSelector);
		}

		unveilObj.unveil(c.threshhold, function() {
			unveilCallback($(this));
			// console.log( 'events after:', $._data(this, 'events') );
		});
	}

	/**
	 * unveil callback
	 * @param {string} or {jQuery} selector string or jQuery object
	 */
	function unveilCallback(obj) {

		if (!obj.hasClass(c.loaded)) {

			obj.parent().addClass(c.loading);

			obj.on('load', function() {

				obj.css({
					opacity: 1
				}).addClass(c.loaded)
				.parent().removeClass(c.loading);

				if (typeof c.loadCallBack === 'function') {
					c.loadCallBack();
				}
			});
		}
	}

	/**
	 * responsive resize
	 */
	function responsiveResize() {
		$(window).on('resize', SDG.debounce(function() {
			responsiveInit();
		}, c.responsive_refresh));
	}

	/**
	 * trigger on load
	 * @param {string} obj selector
	 */
	function triggerOnLoad(obj) {
		$(obj).trigger('unveil');
	}

	return {
		init: init,
		runUnveil: runUnveil
	};
};

/**
 * sequential lazy load (vanilla)
 * @param  {Object} opts
 * @return {Object}
 */
SDG.sequentialLazyLoad = function(opts) {
	var config = {
			numberToLoad: 10,
			groupLoadDelay: 1000,
			class: {
				loaded: 'is-loaded',
				loading: 'is-loading',
				loadMoreBtn: 'sequential-load-more__btn',
				loadMoreContainer: 'sequential-load-more',
			},
			id: {
				content: 'pageContent',
				loadMoreBtn: 'loadMoreBtn',
				loadMoreContainer: 'loadMoreContainer',
			}
		},
		c = SDG.extend(config, opts),
		__ = SDG.util(),

		// globals
		btnExists = false,
		content = document.getElementById(c.id.content),
		imagesToLoad = [],
		index,
		imageGroup,

		// sub modules
		setup = {},
		img = {},
		group = {},
		btn = {};

	/**
	 * init
	 */
	setup.init = function () {
		setup.setImagesInArray();
		setup.loadMorebutton();
		group.load();
	};

	/**
	 * set images in array
	 */
	setup.setImagesInArray = function() {
		var images = content.getElementsByTagName('img'),
			imagesLength = images.length,
			i;

		// loop through images pushing each item to array if visible
		for (i = 0; i < imagesLength; i++) {
			if (__.isVisible(images[i])) {
				imagesToLoad.push(images[i]);
			}
		}
	};

	/**
	 * setup load more button
	 * if there are more than numberToLoad (10) images, add 'load more' button
	 */
	setup.loadMorebutton = function() {
		if (img.getRemainingCount() > c.numberToLoad) {
			btnExists = true;
			btn.append();
		}
	};

	/**
	 * group load
	 */
	group.load = function() {

		// set index, image group
		index = 0;
		imageGroup = imagesToLoad.slice(0, c.numberToLoad);

		// begin to load images sequentially
		if (group.hasRemaining()) {
			img.load(imageGroup[index]);
		}
	};

	/**
	 * load with delay
	 * disable button, add loading class, and trigger group.load fn with delay
	 */
	group.loadWithDelay = function() {
		if (group.hasRemaining()) {
			btn.enabled(false);
			btn.loading(true);
			setTimeout(group.load, c.groupLoadDelay);
		}
	};

	/**
	 * group done
	 */
	group.done = function() {

		// if button exists
		if (btnExists) {

			// update
			btn.update();

			// remove loading class
			btn.loading(false);

			// enable
			btn.enabled(true);

			// if there are no more images remaining, hide the load more button
			if (! img.hasRemaining()) {
				btn.hide();
			}
		}
	};

	/**
	 * group get remaining count
	 * @return {number} number of images remaining in group
	 */
	group.getRemainingCount = function() {
		return imageGroup.length;
	};

	/**
	 * group has remaining
	 * @return {Boolean}
	 */
	group.hasRemaining = function() {
		return imageGroup.length > 0;
	};

	/**
	 * img load
	 * @param {Element} image
	 */
	img.load = function(image) {
		var dataSrc = image.getAttribute('data-src');

		// set image source
		image.setAttribute('src', dataSrc);

		// if image is already loaded (cached)
		if (image.complete) {
			img.done(image);
		}

		// else bind event listeners
		else {

			image.addEventListener('load', function() {
				img.done(this);
			});

			image.addEventListener('error', function() {
				console.warn('error loading ' + this);
			});
		}
	};

	/**
	 * img done
	 * @param {Element} image
	 */
	img.done = function(image) {

		// set loaded style by adding loaded class to image
		// slight delay to ensure fade-in effect
		setTimeout(function() {
			__.addClass(image, c.class.loaded);
		}, 10);

		// load images sequentially
		img.loadSequentially(image);
	};

	/**
	 * img load sequentially
	 * @param {Element} image
	 */
	img.loadSequentially = function(image) {
		var imageIndex = imagesToLoad.indexOf(image);

		// remove image from global array
		if (imageIndex !== -1) {
			imagesToLoad.splice(imageIndex, 1);
		}

		// if next image does not exist, exit function,
		// i.e. group is done loading
		if (index >= group.getRemainingCount() - 1) {
			group.done();
			return false;
		}

		// increase index
		index++;

		// load next image
		img.load(imageGroup[index]);
	};

	/**
	 * img get remaining count
	 * @return {number} number of images remaining in global 'imagesToLoad' array
	 */
	img.getRemainingCount = function() {
		return imagesToLoad.length;
	};

	/**
	 * img has remaining
	 * @return {Boolean}
	 */
	img.hasRemaining = function() {
		return imagesToLoad.length > 0 ? true : false;
	};

	/**
	 * btn append
	 */
	btn.append = function() {
		var containerNode = document.createElement('DIV'),
			btnNode = document.createElement('BUTTON'),
			textNode = document.createTextNode('Load More');

		// setup ids/classes, disable button
		containerNode.id = c.id.loadMoreContainer;
		containerNode.className = c.class.loadMoreContainer;

		btnNode.id = c.id.loadMoreBtn;
		btnNode.className = c.class.loadMoreBtn;
		btnNode.disabled = true;

		// assemble the 'load more' div
		btnNode.appendChild(textNode);
		containerNode.appendChild(btnNode);

		// append div to content
		content.appendChild(containerNode);

		// bind click
		document.getElementById(c.id.loadMoreBtn).addEventListener('click', group.loadWithDelay, false);
	};

	/**
	 * btn enabled
	 * @param {Boolean} isEnabled
	 */
	btn.enabled = function(isEnabled) {
		var btn = document.getElementById(c.id.loadMoreBtn);

		btn.disabled = isEnabled ? false : true;
	};

	/**
	 * btn update
	 * update the number of images remaining to load
	 */
	btn.update = function() {
		var btn = document.getElementById(c.id.loadMoreBtn),
			text = 'Load More (' + img.getRemainingCount() + ')';

		btn.innerHTML = text;
	};

	/**
	 * btn loading
	 * @param {Boolean} isLoading
	 */
	btn.loading = function(isLoading) {
		var container = document.getElementById(c.id.loadMoreContainer);

		if (isLoading) {
			__.addClass(container, c.class.loading);
		} else {
			__.removeClass(container, c.class.loading);
		}
	};

	/**
	 * btn hide
	 */
	btn.hide = function() {
		var container = document.getElementById(c.id.loadMoreContainer);

		container.style.display = 'none';
	};

	return {
		init: setup.init
	};
};

/**
 * mailchimp subscribe
 */
SDG.mailChimp = function(opts) {
	var c = opts;
	var $form = $('#' + c.form);
	var $formBtn =  $('#' + c.form + ' ' + c.btn);

	$form.on('submit', function(e) {
		e.preventDefault();
	});

	$formBtn.on('click', function() {

		$form.ajaxChimp({
			callback: function(response) {
				if (response.result === 'success') {
					onSuccess();
				} else {
					onError();
				}
			}
		});

		function onSuccess() {
			console.log('success');
		}

		function onError() {
			console.log('error');
		}
	});
};

/**
 * modal
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.modal = function(opts) {
	var config = {
			obj: '.modal',
			trigger: '.modal__trigger',
			close: '.modal__close',
			obj_inner: '.modal__inner',
			visible: 'modal--visible',
			overlay: '.modal__overlay',
			overlay_visible: '.modal__overlay--visible',
			overflow: 'overflow--hidden',
			timer: 250,
			closeCallback: null,
			openCallback: null,
			close_from_outside: false,
			is_open: false,
			autoshow: false,
			autoshow_delay: 250,
			exclude_selectors_from_parent: '',
		},
		c = $.extend(config, opts);

	/**
	 * init
	 */
	function init() {
		triggerOpenModal();
		bindCloseClick();
		bindCloseKeyPress();

		if (c.autoshow === true) {

			setTimeout(function() {

				openModal(c.obj);

			}, c.autoshow_delay);

		}
	}

	/**
	 * trigger open modal
	 */
	function triggerOpenModal() {
		$('body').on('click touchevent', c.trigger, function(e) {
			e.preventDefault();

			var modalToOpen = $(this).data('modal-open'),
				$button = $(this);

			// if (!$(this).hasClass('is-disabled')) {
				if ($(this).hasClass('trigger-active')) {
					setTimeout(function() {
						$button.removeClass('trigger-active');
					}, 100);

					closeModal($('#' + modalToOpen));
				} else {
					setTimeout(function() {
						$button.addClass('trigger-active');
					}, 100);

					$(this).siblings().removeClass('trigger-active');

					closeModal($('.'+c.visible));
					openModal(modalToOpen);
				}
		});
	}

	/**
	 * open modal
	 * @param {string} el selector with or without leading hash (#)
	 */
	function openModal(el) {

		if (el.match('^#')) {
			el = el.replace('#', '');
		}

		var modalClass = el + '-open';
		$('body').addClass(c.overflow + ' ' + modalClass);
		$('body').css({ 'position' : 'fixed' });
		//alert('body fixed');

		$('#' + el).addClass(c.visible)
		.next(c.overlay).addClass(c.visible + ' modal__' + el);

		setTimeout(function() {
			c.is_open = true;
			if (c.openCallback) {
				c.openCallback();
			}
		}, c.timer);
	}

	/**
	 * close modal
	 * @param  {jQuery} el jQuery object
	 */
	function closeModal(el) {
		var modalClass;

		if (typeof el === 'object') {
			modalClass = el.attr('id') + '-open';
		} else {
			modalClass = el + '-open';
		}

		$(el).removeClass(c.visible)
		.next(c.overlay).removeClass(c.visible);
		$('body').removeClass(c.overflow + ' ' + modalClass);
		$('body').css({ 'position' : 'initial' });

		setTimeout(function() {
			// if (window.location.hash) window.location.hash = '';

			if ($('.trigger-active').length === 0) {
				$('body').removeClass(c.overflow);
				$('body').removeAttr('style');
				c.is_open = false;
			}

			$('body').removeClass(modalClass);

			if (typeof c.closeCallback === 'function') {
				c.closeCallback();
			}

		}, c.timer);
	}

	/**
	 * bind close click
	 */
	function bindCloseClick() {
		$('body').on('click', c.close, function(e) {
			e.preventDefault();
			closeModal($('.' + c.visible));
		});

		if (c.close_from_outside) {
			$(document).on('click', function(e) {
				if (c.exclude_selectors_from_parent) {
					var targetParent = __.parents(e.target, c.exclude_selectors_from_parent);
					if (targetParent) return;
				}

				if ($('.trigger-active').length > 0) {
					var container = $('.modal--visible').find('.modal__wrap');
					if (!container.is(e.target) && container.has(e.target).length === 0) {
						closeModal($('.' + c.visible));
						$('.trigger-active').removeClass('trigger-active');
					}
				}
			});

			$('body').on('touchstart', function (e) {
				if (c.exclude_selectors_from_parent) {
					var targetParent = __.parents(e.target, c.exclude_selectors_from_parent);
					if (targetParent) return;
				}

				if ($('.trigger-active').length > 0) {
					var container = $('.modal--visible').find('.modal__wrap');
					if (!container.is(e.target) && container.has(e.target).length === 0) {
						closeModal($('.' + c.visible));
						// $('.trigger-active').removeClass('trigger-active');
					}
				}
			});

		}
	}

	/**
	 * bind close key press
	 */
	function bindCloseKeyPress() {

		$(document).keyup(function(e) {

			if (e.keyCode === 27) {
				closeModal($('.' + c.visible));
			}
		});
	}


	return {
		init: init,
		open: openModal,
		close: closeModal
	};
};

/**
 * accordion
 * parentTrigger = the click object
 * childContainer = the container you want to have slide open
 * If you want a menu item open by default, add "open" to the child container.
 * @param {Object} opts options
 */
SDG.accordion = function(opts) {
	var config = {
			id: '#accordion',
			trigger: '.accordion__trigger',
			menu: '.accordion__content',
			scroll_scope: 'html,body',
			scroll_offset: 60,
			active: 'active',
			menu_open: 'open',
			timer: 350,
			type: 'accordion',
			open_if_active: null,
			open_callback: null,
			close_callback: null,
			responsive: null,
			active_views: null,
			inactive_views: null,
			current_view: null
		},
		c = $.extend(config, opts);

	/**
	 * init
	 */
	function init() {

		if (c.responsive) {
			responsive();
			windowResize();
		} else {
			bindToggle();
		}

		openIfActive($(this));
	}

	/**
	 * bind toggle
	 */
	function bindToggle() {

		$(c.id).on('click', c.trigger, function(e) {

			if ($(this).next(c.menu).length) {
				e.preventDefault();
			}

			state($(this));
		});
	}

	/**
	 * unbind toggle
	 */
	function unbindToggle() {
		$(c.id).off('click', c.trigger);
		clearStyles();
	}

	/**
	 * open if active
	 * @param  {jQuery} obj jQuery object
	 */
	function openIfActive(obj) {
		if (c.open_if_active && obj) {

			if ($(c.id).find(c.menu).find('a').hasClass('highlight')) {

				$(c.id).find('.highlight').parents('.facet__container').find(c.trigger).addClass('active');
				$(c.id).find('.highlight').parents(c.menu).addClass('open').show();

			}
		}
	}

	/**
	 * state
	 * @param  {jQuery} obj jQuery object
	 */
	function state(obj) {

		if (obj.hasClass(c.active)) {
			if (c.type === 'accordion') {
				focusViewport($(c.id));
			}
			closeAccordion(obj);
		} else {
			focusViewport(obj);
			openAccordion(obj);
		}
	}

	/**
	 * open accordion
	 * @param  {jQuery} obj jQuery object
	 */
	function openAccordion(obj) {

		if (c.type === 'accordion') {
			closeAccordion();
		}

		obj.addClass(c.active);

		obj.next(c.menu)
		.addClass(c.menu_open)
		.slideDown(c.timer);

		if (c.open_callback) {
			c.open_callback();
		}
	}

	/**
	 * close accordion
	 * @param  {jQuery} obj jQuery object
	 */
	function closeAccordion(obj) {

		if (obj) {
			obj.removeClass(c.active)
			.next(c.menu)
			.removeClass(c.menu_open)
			.slideUp(c.timer);
		} else {
			$(c.id).find('.' + c.active)
			.removeClass(c.active)
			.next(c.menu)
			.removeClass(c.menu_open)
			.slideUp(c.timer);
		}

		if (typeof c.close_callback === 'function') {
			c.close_callback();
		}
	}

	/**
	 * focus viewport
	 * @param {jQuery} obj jQuery Object
	 * @param {number} pos scrollTop position
	 */
	function focusViewport(obj, pos) {

		if (c.scroll_scope) {

			setTimeout(function() {

				var offset;
				if (c.scroll_offset) {
					offset = ($(c.scroll_scope).scrollTop() + obj.offset().top) - c.scroll_offset;
				} else {
					offset = $(c.scroll_scope).scrollTop() + obj.offset().top;
				}

				$(c.scroll_scope).animate({
					scrollTop: pos === undefined ? offset : pos
				}, c.timer, 'swing');

			}, c.timer);
		}
	}

	/**
	 * window resize
	 */
	function windowResize() {
		$(window).on('resize', SDG.debounce(function() {
			responsive();
		}));
	}

	/**
	 * responsive
	 */
	function responsive() {
		var active_views = c.active_views,
			inactive_views = c.inactive_views;

		$.each(active_views, function(index, value) {
			var view = value;

			if (c.current_view !== view) {
				var activeViewsMq = SDG.mq({
					view: view,
					callback: function() {
						c.current_view = view;
						bindToggle();
					}
				});
				activeViewsMq.init();
			}
		});

		$.each(inactive_views, function(index, value) {
			var view = value;

			if (c.current_view !== view) {
				var inactiveViewsMq = SDG.mq({
					view: view,
					callback: function() {
						c.current_view = view;
						unbindToggle();
					}
				});
				inactiveViewsMq.init();
			}
		});
	}

	/**
	 * clear styles
	 */
	function clearStyles() {
		$(c.id).find(c.trigger).removeClass(c.active)
		.next(c.menu).removeClass(c.menu_open).removeAttr('style');
	}

	return {
		init: init,
		open: openAccordion,
		close: closeAccordion
	};
};

/**
 * sticky
 * @param  {Object} opts options
 * @return {Object}
 * @todo handle responsive images on load event
 */
SDG.sticky = function(opts) {
	var config = {
			content: '#content',
			sticky: '#sticky',
			stickyParent: null,
			threshold: 300,
			class: {
				unstuck: 'is-unstuck'
			}
		},
		flag = {
			view: null
		},
		c = SDG.extend(config, opts),

		// globals
		$sticky = $(c.sticky),
		$stickyParent = c.stickyParent === null ? $(c.sticky).parent() : $(c.stickyParent);

	/**
	 * init
	 */
	function init() {
		responsiveInit();
		bindWindowResizeResponsive();
	}

	/**
	 * responsive init
	 */
	function responsiveInit() {
		var	mqPhone = SDG.mq({
				view: 'phone',
				callback: function() {
					fireOnce(this.view, phoneCallback);
				}
			}),
			mqTablet = SDG.mq({
				view: 'tablet',
				callback: function() {
					fireOnce(this.view, tabletCallback);
				}
			});

		mqPhone.init();
		mqTablet.init();
	}

	/**
	 * fire once
	 * @param {string}   view
	 * @param {Function} callback
	 */
	function fireOnce(view, callback) {
		if (flag.view !== view) {
			flag.view = view;
			if (typeof callback === 'function') {
				callback();
			}
		}
	}

	/**
	 * phone callback
	 */
	function phoneCallback() {
		unbindStickyEvents(resetStyles);
	}

	/**
	 * tablet callback
	 */
	function tabletCallback() {
		setStyles();
		bindStickyEvents();
	}

	/**
	 * bind window resize responsive
	 */
	function bindWindowResizeResponsive() {
		$(window).on('resize.responsive', SDG.debounce(responsiveInit, c.threshold));
	}

	/**
	 * bind sticky events
	 */
	function bindStickyEvents() {
		$(window).on('resize.sticky', SDG.debounce(setStyles, c.threshold));

		if (! Modernizr.csspositionsticky) {
			$(document).on('scroll.fallback', fallbackToggleSticky);
		}
	}

	/**
	 * unbind sticky events
	 * @param {Function} callback fired after events are unbinded
	 */
	function unbindStickyEvents(callback) {
		$(window).off('resize.sticky');

		if (! Modernizr.csspositionsticky) {
			$(document).off('scroll.fallback');
		}

		if (typeof callback === 'function') {
			setTimeout(callback, 100);
		}
	}

	/**
	 * fallback toggle sticky
	 */
	function fallbackToggleSticky() {
		var windowScrollTop = $(window).scrollTop(),
			contentHeight = $(c.content).outerHeight(),
			stickyHeight = $sticky.outerHeight(),
			bottom = contentHeight - stickyHeight;

		if ( windowScrollTop > bottom ) {
			$sticky.addClass(c.class.unstuck);
		}
		else {
			$sticky.removeClass(c.class.unstuck);
		}
	}

	/**
	 * set styles
	 */
	function setStyles() {
		var contentHeight = $(c.content).outerHeight();

		// update sticky's parent styles
		$stickyParent.css({
			height: contentHeight,
			position: 'relative'
		});
	}

	/**
	 * reset styles
	 */
	function resetStyles() {

		// update sticky's parent styles
		$stickyParent.css({
			height: 'auto',
			position: 'static'
		});

		$sticky.removeClass(c.class.unstuck);
	}

	return {
		init: init
	};
};

/**
 * size guide
 * @return {Object}
 */
SDG.sizeGuide = function() {

	/**
	 * init
	 */
	function init() {
		bindClicks();
		loop();
	}

	/**
	 * loop
	 */
	function loop() {
		var columns = 10,
			column,
			i;

		for (i = 1; i <= columns; i++) {
			column = '.column-' + i;
			bindHover(column);
		}
	}

	/**
	 * bind hover
	 * @param {string} column selector
	 */
	function bindHover(column) {
		$(column).hover(
			function() {
				$(column).css('background-color', '#f2f2f2');
			}, function() {
				$(column).css('background-color', 'transparent');
			}
		);
	}

	/**
	 * bind clicks
	 */
	function bindClicks() {
		$('.inches').on('click', showInches);
		$('.cm').on('click', showCentimeters);
		$('#sizeGuideProductTrigger').on('click', showSizeGuideProduct);
		$('#sizeGuideBodyTrigger').on('click', showSizeGuideBody);
		$('#sizeGuideCloseMobile').on('click', function() {
			$.fancybox.close();
		});
	}

	/**
	 * show inches
	 */
	function showInches(e) {
		e.preventDefault();
		$('.table-cm').css('display', 'none');
		$('a.cm').removeClass('active');
		$('.table-inches').css('display', 'block');
		$('a.inches').addClass('active');
	}

	/**
	 * show centimeters
	 */
	function showCentimeters(e) {
		e.preventDefault();
		$('.table-inches').css('display', 'none');
		$('a.inches').removeClass('active');
		$('.table-cm').css('display', 'block');
		$('a.cm').addClass('active');
	}

	/**
	 * show Size Guide Product Measurements
	 */
	function showSizeGuideProduct(e) {
		e.preventDefault();
		$('#sizeGuideBodyMeasurements').css('display', 'none');
		$('#sizeGuideProductMeasurements').css('display', 'flex');
		$('#sizeGuideBodyTrigger').removeClass('active');
		$('#sizeGuideProductTrigger').addClass('active');
			if($('#modalSizeGuide')){
				$('#sizeGuideBodyMeasurements').css('display', 'none');
				$('#modalSizeguideWrap').css('display', 'block');
			}
	}

	/**
	 * show Size Guide Body Measurements
	 */
	function showSizeGuideBody(e) {
		e.preventDefault();
		$('#sizeGuideProductMeasurements').css('display', 'none');
		$('#sizeGuideBodyMeasurements').css('display', 'flex');
		$('#sizeGuideProductTrigger').removeClass('active');
		$('#sizeGuideBodyTrigger').addClass('active');
		if($('#modalSizeGuide')){
			$('#sizeGuideBodyMeasurements').css('display', 'flex');
			$('#modalSizeguideWrap').css('display', 'none');
		}
	}

	return {
		init: init
	};
};

/**
 * variant label
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.variantLabel = function(opts) {
	var config = {
			label: '.variant_label'
		},
		c = SDG.extend(config, opts);

	/**
	 * init
	 */
	function init() {
		bindClick();
	}

	/**
	 * bind click
	 */
	function bindClick() {
		$(c.label).click(update);
	}

	/**
	 * update
	 */
	function update() {
		var product_id = $(this).not('#giftcard-amount').attr('data-product');

		$(c.label).css('border-bottom', '2px solid #fff');
		$(this).css('border-bottom', '2px solid #000');
		$('.cart_' + product_id).val(jeSettings.text_add_to);
		$('.cart_' + product_id).removeAttr('disabled');
	}

	return {
		init: init
	};
};

/**
 * flash sale
 * based off of example from:
 * https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.flashSale = function(opts) {
 	var config = {
	 		counter: 60000,
	 		day: jeSettings.flash_sale_end_day,
	 		days: '.js-days',
	 		daysSpan: null,
	 		endTime: null,
	 		hour: jeSettings.flash_sale_end_hour,
	 		hours: '.js-hours',
	 		hoursSpan: null,
	 		id: null,
	 		interval1: null,
	 		interval2: null,
	 		intro: '.js-intro',
	 		introSpan: null,
	 		marquee: null,
	 		marqueeScroll: null,
	 		marqueeScrollTarget: '.js-marquee',
	 		minute: jeSettings.flash_sale_end_minute,
	 		minutes: '.js-minutes',
	 		minutesSpan: null,
	 		month: jeSettings.flash_sale_end_month,
	 		year: jeSettings.flash_sale_end_year,
	 		flag: {
	 			updatedInterval: false,
	 			updatedIntro: false
	 		}
	 	},
		c = SDG.extend(config, opts);

	/**
	 * init
	 */
 	function init() {
		if ($('body').hasClass('template-product')) {
			setMarqueeWidth();

			$(window).resize(setMarqueeWidth);
		}


		// Check DST and set GMT time
		var dst = checkDST(c.month + ' ' + c.day + ', ' + c.year + ' ' + c.hour + ':' + c.minute + ':00');
		var gmt = ' GMT-0800';

		if (dst) {
			gmt = ' GMT-0700';
		}

		function fireMarquee() {

			if (typeof(templatePage) !== 'undefined' && (templatePage === 'collection' || templatePage === 'search')) {

				$(templatePageID).find('.has-flash-sale').each(function() {
				    c.id = 'marquee-' + $(this).attr("data-marquee");

					targetMarquee();
					// Init update function
					updateClock();
				});
			} else {

				c.id = 'marquee-' + productJson.id;
				targetMarquee();
				// Init update function
				updateClock();
			}
		}

		fireMarquee();


		if (typeof(templatePage) !== 'undefined' && (templatePage === 'collection' || templatePage === 'search')) {

			$(templatePageID).find('.has-flash-sale').each(function() {
				createMarquee($(this));
			});
		}

		if ($('body').hasClass('template-product')) {
			createMarquee($('.marquee--product'));
		}

		function targetMarquee() {
			c.endTime = new Date(c.month + ' ' + c.day + ', ' + c.year + ' ' + c.hour + ':' + c.minute + ':00' + gmt).toISOString();
			c.marquee = document.getElementById(c.id);
			c.marqueeScroll = c.marquee.querySelector(c.marqueeScrollTarget);
			c.introSpan = c.marquee.querySelector(c.intro);
			c.daysSpan = c.marquee.querySelector(c.days);
			c.hoursSpan = c.marquee.querySelector(c.hours);
			c.minutesSpan = c.marquee.querySelector(c.minutes);
		}



		// if ($(window).width() > 768 || !$('body').hasClass('template-collection')) {
			// Set inital interval
			 c.interval1 = setInterval(fireMarquee, c.counter);
		// }


	}

	function setMarqueeWidth() {
		var $pdpInner = $('.pdp__inner'),
			pdpInnerWidth = $pdpInner.width();

		var $carouselImage = $('#carousel').find('.product-carousel__image'),
			imageWidth = $carouselImage.width() - 50;

		var $carousel = $('#carousel'),
			carouselWidth = $carousel.width() - 103;

		var marqueeWidth = carouselWidth - pdpInnerWidth;

		if ($pdpInner) {
			if (marqueeWidth > 0) {
				$('.marquee').css({ 'width' : marqueeWidth + 'px' });
			} else {
				$('.marquee').css({ 'width' : '100%' });
			}
			$('.product-carousel').css({ 'margin-top' : 50 + 'px' });
		} else {
			$('.marquee').css({ 'width' : imageWidth + 'px' });
		}

	}

	function createMarquee($el) {
		var $jsMarquee = $el.find('.js-marquee');

		if (!$el.hasClass('is-flashsale')) {
			animateMarquee($jsMarquee);
			$el.addClass('is-flashsale');
		}
	}

	function animateMarquee($el) {
		var marqueeWidth = $el.width(),
			initDistance = $el.find('.marquee__inner').width() + 21,
			scrollDistance = marqueeWidth,
			repeatDistance = initDistance,
			i = 0,
			$clone = $el.html(),
			myInt;

		$el.append($clone).append($clone).append($clone);
		//scrollDistance += initDistance;
		// i += 10;

		myInt = setInterval(function() {
			// $el.css({ 'transform': 'translateX(-'+ i +'px)'});
			$el.css({ 'left': '-'+ i +'px'});

			if (i < scrollDistance) {
				i += 2;
			} else {
				scrollDistance += initDistance;
				// $el.append($clone);
			}
			if (i > repeatDistance) {
				// clearInterval(myInt);
				i = 0;
				scrollDistance = initDistance;
				// $el.html($clone);
			}
		}, 100);

	}

	/**
	 * build marquee
	 */
	// function buildMarquee() {
	// 	var scroller = $(c.marqueeScroll), // element(s) to scroll
	// 		scrollingVelocity = 92, // 1-99
	// 		scrollingFrom = 'right'; // 'right' or 'left'
	//
	// 	// Begin scrolling
	// 	startScrolling(scroller, scrollingVelocity, scrollingFrom);
	// }

	/**
	 * update clock
	 */
	function updateClock() {
		var t = getTimeRemaining(c.endTime);

		// Set values
		c.daysSpan.innerHTML = t.days;
		c.hoursSpan.innerHTML = t.hours;
		//c.minutesSpan.innerHTML = t.minutes;
		$(c.minutes).html(t.minutes);


		// Watch total
		watchTotal(t.total);

		// Watch values
		watchValues({
			days: {
				el: c.daysSpan,
				value: t.days
			},
			hours: {
				el: c.hoursSpan,
				value: t.hours
			},
			minutes: {
				el: c.minutesSpan,
				value: t.minutes
			}
		});
	}

	/**
	 * watch total
	 * @param {number} total number in milliseconds
	 */
	function watchTotal(total) {

		// If total is less than or equal to 2 minutes
		if (total <= 120000 && !c.flag.updatedInterval) {

			// Clear initial interval
			clearInterval(c.interval1);

			// Create new interval that runs every second
			c.interval2 = setInterval(updateClock, 1000);
			c.flag.updatedInterval = true;
		}

		// If total is less 1 minute
		if (total < 60000 && !c.flag.updatedIntro) {

			// Change intro text
			c.introSpan.innerHTML = 'Flash sale ends in 1 minute';
			c.flag.updatedIntro = true;
		}

		// If time remaining is 0
		if (total <= 0) {

			// Hide marquee
			c.marquee.style.display = 'none';

			// Clear interval2
			clearInterval(c.interval2);
		} else {
			c.marquee.style.display = 'inline-block';
		}
	}

	/**
	 * watch values
	 * @param {Object} values object with days/hours/minutes values
	 */
	function watchValues(values) {

		// Loop over the values
		for (var key in values) {
			if (values.hasOwnProperty(key)) {

				// If value is 0, hide the element's container, else show it
				if (values[key].value === 0) {
					values[key].el.parentElement.style.display = 'none';
				} else {
					values[key].el.parentElement.style.display = 'inline';
				}

				// Days specific logic
				// If days is equal to 1, set the text to 'Day', else set it to 'Days'
				if (key === 'days') {
					if (values[key].value === 1) {
						values[key].el.nextElementSibling.innerHTML = 'Day';
					} else {
						values[key].el.nextElementSibling.innerHTML = 'Days';
					}
				}

				// Hours specific logic
				// If hours is equal to 1, set the text to 'Hr', else set it to 'Hrs'
				if (key === 'hours') {
					if (values[key].value === 1) {
						values[key].el.nextElementSibling.innerHTML = 'Hr';
					} else {
						values[key].el.nextElementSibling.innerHTML = 'Hrs';
					}
				}
			}
		}
	}

	/**
	 * get time remaining
	 * @param {Date} endTime
	 */
	function getTimeRemaining(endTime) {
		var t = Date.parse(endTime) - Date.parse(new Date()),
			minutes = Math.floor((t / 1000 / 60) % 60),
			hours = Math.floor((t / (1000 * 60 * 60)) % 24),
			days = Math.floor(t / (1000 * 60 * 60 * 24));

		return {
			'total': t,
			'days': days,
			'hours': hours,
			'minutes': minutes
		};
	}

	/**
	 * start scrolling
	 * @param  {jQuery} scroller_obj jQuery object
	 * @param  {number} velocity     number ranging from 1-99
	 * @param  {string} start_from   direction: 'right' or 'left'
	 */
	// function startScrolling(scroller_obj, velocity, start_from) {
	// 	//bind animation  inside the scroller element
	// 	scroller_obj.bind('marquee', function(event, c) {
	// 		//text to scroll
	// 		var ob = $(this);
	// 		//scroller width
	// 		var sw = parseInt(ob.parent().outerWidth());
	// 		//text width
	// 		var tw = parseInt(ob.outerWidth());
	// 		//text left position relative to the offset parent
	// 		var tl = parseInt(ob.position().left);
	// 		//velocity converted to calculate duration
	// 		var v = velocity > 0 && velocity < 100 ? (100 - velocity) * 1000 : 5000;
	// 		//same velocity for different text's length in relation with duration
	// 		var dr = (v * tw / sw) + v;
	// 		//is it scrolling from right or left?
	// 		switch (start_from) {
	// 			case 'right':
	// 				//is it the first time?
	// 				if (typeof c === 'undefined') {
	// 					//if yes, start from the absolute right
	// 					ob.css({
	// 						left: sw
	// 					});
	// 					sw = -tw;
	// 				} else {
	// 					//else calculate destination position
	// 					sw = tl - (tw + sw);
	// 				}
	// 				break;
	// 				default:
	// 				if (typeof c === 'undefined') {
	// 					//start from the absolute left
	// 					ob.css({
	// 						left: -tw
	// 					});
	// 				} else {
	// 					//else calculate destination position
	// 					sw += tl + tw;
	// 				}
	// 			}
	// 		//attach animation to scroller element and start it by a trigger
	// 		ob.animate({
	// 			left: sw
	// 		}, {
	// 			duration: dr,
	// 			easing: 'linear',
	// 			complete: function() {
	// 				ob.trigger('marquee');
	// 			},
	// 			step: function() {
	// 				//check if scroller limits are reached
	// 				if (start_from === 'right') {
	// 					if (parseInt(ob.position().left) < -parseInt(ob.outerWidth())) {
	// 						//we need to stop and restart animation
	// 						ob.stop();
	// 						ob.trigger('marquee');
	// 					}
	// 				} else {
	// 					if (parseInt(ob.position().left) > parseInt(ob.parent().outerWidth())) {
	// 						ob.stop();
	// 						ob.trigger('marquee');
	// 					}
	// 				}
	// 			}
	// 		});
	// 	}).trigger('marquee');
	// 	//pause scrolling animation on mouse over
	// 	scroller_obj.parent().mouseover(function() {
	// 		scroller_obj.stop();
	// 	});
	// 	//resume scrolling animation on mouse out
	// 	scroller_obj.parent().mouseout(function() {
	// 		scroller_obj.trigger('marquee', ['resume']);
	// 	});
	// }

	/**
	 * check dst
	 * http://stackoverflow.com/a/11888430
	 * @param  {string}  date
	 * @return {boolean}
	 */
	function checkDST(date) {
		var endDate = new Date(date),
			endDateInstance = new DateHelper(endDate);

		// constructor
		function DateHelper(date) {

			if (! (this instanceof DateHelper)) {
				return new DateHelper(date);
			}

			this.date = date;
		}

		DateHelper.prototype.stdTimezoneOffset = function() {
			var jan = new Date(this.date.getFullYear(), 0, 1);
			var jul = new Date(this.date.getFullYear(), 6, 1);
			return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
		};

		DateHelper.prototype.dst = function() {
			return this.date.getTimezoneOffset() < this.stdTimezoneOffset();
		};

		if (endDateInstance.dst()) {
			return true;
		}

		return false;
	}

	return {
		init: init
	};
};

/**
 * notify
 * captures Klaviyo submit event that pushes email to the
 * "Pre-Launch Product Notification" list. Upon success,
 * initializes BackInStock and Google Analytics events
 * @param  {Object} opts options
 * @return {Object}
 */
SDG.notify = function(opts) {
	var config = {
			container: null,
			email: '.js-email',
			$email: null,
			formId: 'notifyForm',
			messages: '.js-messages',
			$messages: null,
			productId: null,
			productTitle: null,
			submit: '.js-submit',
			$submit: null,
			variantId: null,
			triggerBtn: '.product-get-notify__btn',
			$triggerBtn: null
		},
		c = SDG.extend(config, opts);

	/**
	 * init
	 */
	function init() {

		// globals
		c.productId = productJson.id;
		c.productTitle = productJson.title;
		c.variantId = productJson.variants[0].id;
		c.form = '#'+c.formId; // '#productNotify-' + c.productId;
		c.$email = $(c.form).find(c.email);
		c.$messages = $(c.form).find(c.messages);
		c.$submit = $(c.form).find(c.submit);
		c.$triggerBtn = $(c.form).find(c.triggerBtn);

		// init functions
		bindEvents();
	}

	/**
	 * bind events
	 */
	function bindEvents() {

		// Bind submit click
		c.$submit.click(function() {

			// Unfocus email input
			c.$email.blur();
		});

		// Init Klaviyo functions
		klaviyoSubmit();

		// Init get notified button
		getNotifiedBtn();
	}

	/**
	 * klaviyo submit
	 */
	function klaviyoSubmit() {

	 	KlaviyoSubscribe.attachToForms(c.form, {
	 		hide_form_on_success: false,
	 		success: submitSuccess,
	 		success_message: 'Thanks. Check your email for updates.'
	 	});
	}

	/**
	 * submit success
	 */
	function submitSuccess() {
	 	// var email = c.$email.val();

		// BackInStock, create the notification
		// BIS.create(email, c.variantId, c.productId);

		// Google Analytics event
		ga('send', 'event', 'preLaunchNotification', 'Submit', c.productTitle);

		// Hide messages
		setTimeout(hideMessages, 5000);
	}

	/**
	 * hide messages
	 */
	function hideMessages() {
	 	c.$messages.slideUp(400);
	}

	/**
	 * click action for Get Notified button for disabled product
	 */
	function getNotifiedBtn() {
	 	c.$triggerBtn.on('click', function() {
	 		$(this).addClass('hide');
	 		$(c.form).removeClass('hide');
	 	});
	}

	return {
	 	init: init
	};
};

/**
 * incrementer
 * @return {Object}
 */
SDG.incrementer = function() {

	/**
	 * init
	 */
	function init() {
		bindEvents();
	}

	/**
	 * bind events
	 */
	function bindEvents() {

		// This button will increment the value
		$('.qtyplus').click(function(e){
			// Stop acting like a button
			e.preventDefault();
			// Get the field name
			var fieldName = $(this).attr('field');
			// Get its current value
			var currentVal = parseInt($('input[name='+fieldName+']').val());
			// If is not undefined
			if (!isNaN(currentVal)) {
				// Increment
				$('input[name='+fieldName+']').val(currentVal + 1);
			} else {
				// Otherwise put a 0 there
				$('input[name='+fieldName+']').val(0);
			}
		});

		// This button will decrement the value till 0
		$('.qtyminus').click(function(e) {
			// Stop acting like a button
			e.preventDefault();
			// Get the field name
			var fieldName = $(this).attr('field');
			// Get its current value
			var currentVal = parseInt($('input[name='+fieldName+']').val());
			// If it isn't undefined or its greater than 0
			if (!isNaN(currentVal) && currentVal > 0) {
				// Decrement one
				$('input[name='+fieldName+']').val(currentVal - 1);
			} else {
				// Otherwise put a 0 there
				$('input[name='+fieldName+']').val(0);
			}
		});
	}

	return {
		init: init
	};
};

/**
 * affiliate
 * @return {Object}
 */
SDG.affiliate = function() {

	/**
	 * init
	 */
	function init() {
		onLoad();
	}

	/**
	 * on load
	 */
	function onLoad() {
		window.onload = function() {
			var name = 'source';
			var regexS = '[\\?&]'+name+'=([^&#]*)';
			var regex = new RegExp( regexS, 'gi' );
			var results = regex.exec(window.location.href);
			if (results === null) {
				return '';
			}
			else {
				createCookie(name, results[1], 7);
			}
		};
	}

	/**
	 * create cookie
	 * @param  {string} name
	 * @param  {string} value
	 * @param  {number} days
	 */
	function createCookie(name, value, days) {
		var date,
			expires;
		if (days) {
			date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			expires = '; expires='+date.toGMTString();
		}
		else {
			expires = '';
		}
		document.cookie = name+'='+value+expires+'; path=/';
	}

	return {
		init: init
	};
};

/**
 * Toggle Dropdown
 */
 SDG.toggleDropdown = function (opts) {
 	var config = {
 		cb: {
 			before_open: null,
 			after_open: null,
 			before_close: null,
 			after_close: null
 		},
 		click_outside: {
 			enable: true,
 			exclude_selectors: '' // defaults to c.dom.btn, see 'excludedSelectors' below
 		},
 		cls: {
 			active: 'is-active',
 			visible: 'is-visible'
 		},
 		dom: {
 			btn: 'menuShow',
 			menu: 'menu',
			close: 'js-menu-close', // array of classes
			wrapper: null
 		},
 		timer: {
 			close: null, // Delay for close animation
 			default: 250, // Default delay
 			open: null // Delay for open animation
 		}
 	};

 	/**
   * shorthand config
   * @type {[type]}
   */
 	var c = config;
 	if (opts) c = __.extend(config, opts);

 	/**
   * cached vars
   */
 	var menu = document.getElementById(c.dom.menu);
 	var btn = document.getElementById(c.dom.btn);
	var wrapper = document.getElementById(c.dom.wrapper);
 	var excludedSelectors = c.click_outside && !c.click_outside.exclude_selectors ? '#' + c.dom.btn : c.click_outside.exclude_selectors;

 	/**
   * init
   */
 	function init() {
 		if (menu) {
 			mapTimers();
 			bindEvents();
 			kbEvent();
 			callbacks();
			closeMenuBtns();
 		}
 	}

 	function bindEvents() {
 		__.addEvent({
 			id: c.dom.btn,
 			event: 'click',
 			fn: toggleMenu
 		});

 		if (c.click_outside.enable) {
 			__.clickOutside({
 				callback: toggleMenu,
 				condition: isActive,
 				exclude_selectors: excludedSelectors,
 				selector: '#' + c.dom.menu
 			});
 		}
 	}

 	function toggleMenu() {
 		if (isActive()) {
 			closeMenu();
 		} else {
 			openMenu();
 		}
 	}

 	function openMenu() {
 		__.addClass(btn, c.cls.active);
 		__.addClass(menu, c.cls.visible);

		if (wrapper) {
			__.addClass(wrapper, c.cls.active);
		}

 		// Trigger Callbacks before the menu opens
 		__.trigger(btn, 'beforeToggleOpen');

 		setTimeout(function () {
 			return __.trigger(btn, 'afterToggleOpen');
 		}, c.timer.open);
 	}

 	function closeMenu() {
 		__.removeClass(btn, c.cls.active);
 		__.removeClass(menu, c.cls.visible);

		if (wrapper) {
			__.removeClass(wrapper, c.cls.active);
		}

 		// Trigger callbacks before modal closes
 		__.trigger(btn, 'beforeToggleClose');

 		setTimeout(function () {
 			return __.trigger(btn, 'afterToggleClose');
 		}, c.timer.close);
 	}

	function closeMenuBtns() {
		var cleanBtns = c.dom.close.replace(/\s/g, '');
		var btnsArray = cleanBtns.split(',');

		for (var i = 0; i < btnsArray.length; i += 1) {
			__.addEvent({
				id: c.dom.menu,
				className: btnsArray[i],
				event: 'click',
				fn: closeMenu
			});
		}
	}

 	/**
   * keyboard event
   * @description add key board event on keyup
   */
 	function kbEvent() {
 		document.addEventListener('keyup', getKey);
 	}

 	/**
   * get key pressed
   * @description function that's executed on keypress. checks the keycode value,
   * if it matches with the escape key close all modals.
   */
 	function getKey(e) {
 		if (e.keyCode === 27) {
 			closeMenu();
 		}
 	}

 	function isActive() {
 		return __.hasClass(menu, c.cls.visible);
 	}

 	/**
   * callbacks
   * @type {function}
   */
 	function callbacks() {

 		__.addEvent({
 			id: c.dom.btn,
 			event: 'beforeToggleOpen',
 			fn: function fn() {
 				return c.cb.before_open !== null ? c.cb.before_open() : null;
 			}
 		});

 		__.addEvent({
 			id: c.dom.btn,
 			event: 'afterToggleOpen',
 			fn: c.cb.after_open !== null ? c.cb.after_open() : null
 		});

 		__.addEvent({
 			id: c.dom.btn,
 			event: 'beforeToggleClose',
 			fn: c.cb.before_close !== null ? c.cb.before_close() : null
 		});

 		__.addEvent({
 			id: c.dom.btn,
 			event: 'afterToggleClose',
 			fn: c.cb.after_close !== null ? c.cb.after_close() : null
 		});
 	}

 	/**
   * map timers
   * @description setting close timer and open timer if they are not set
   */
 	function mapTimers() {
 		if (c.timer.close === null) c.timer.close = c.timer.default;
 		if (c.timer.open === null) c.timer.open = c.timer.default;
 	}

 	return init();
 };

/**
 * show quick popup
 * show a quick generic text popup above an element
 * @param  {string} message
 * @param  {jQuery} $origin
 * @return {Object}
 */
SDG.showQuickPopup = function(message, $origin) {

	/**
	 * init
	 */
	function init() {
		showPopup();
	}

	/**
	 * show popup
	 */
	function showPopup() {
		var $popup = $('<div>').addClass('simple-popup');
		var offs = $origin.offset();
		$popup.html(message).css({
			'left': offs.left,
			'top': offs.top
		}).hide();
		$('body').append($popup);
		$popup.css('margin-top', -$popup.outerHeight() - 10);
		$popup.fadeIn(200).delay(3500).fadeOut(400, function() {
			$(this).remove();
		});
	}

	return {
		init: init
	};
};

/*
----------------------------------------------------------------------------
XX. Mega Menu
----------------------------------------------------------------------------
*/
SDG.megaMenu = function() {

	var $header 		= $('mainHdr'),
	$headerNav 			= $('#main-nav'),
	$link 				= $headerNav.find('.submenu__link'),
	$linkUl 			= $headerNav.find('.submenu__ul'),
	$linkLi 			= $headerNav.find('.submenu__li'),
	$submenu 			= $headerNav.find('.submenu__wrap'),
	$closeSubmenu 			= $headerNav.find('.submenu__close'),
	$linkLiClass 		= '.submenu__li',
	$linkUlClass 		= '.submenu__ul',
	activeClass 		= 'is-active',
	timer1,
	timer2;

	function init() {
		menu();
		var lazyImages = SDG.lazyLoad({
			id: '#main-nav'
		});
		lazyImages.init();
	}

	function menu() {
		$submenu.mouseenter(function() {
			clearTimeout(timer1);
			clearTimeout(timer2);
		});

		$linkUl.mouseleave(function(e) {
			$header.removeClass(activeClass);
			$linkLi.removeClass(activeClass);
			$linkUl.removeClass(activeClass);
			closeSubMenu();
		});

		$link.click(function(e) {
			e.preventDefault();

			if ( !$(this).hasClass(activeClass) ) {
				$headerNav.find('.' + activeClass).removeClass(activeClass);
			}

			$(this).closest($linkLiClass).addClass(activeClass);
			$(this).closest($linkUlClass).addClass(activeClass);

			timer1 = setTimeout(function() {
				$header.addClass(activeClass);
			},300);
		});

    $closeSubmenu.click(function(e) {
  		$header.removeClass(activeClass);
  		$linkLi.removeClass(activeClass);
  		$linkUl.removeClass(activeClass);
  		closeSubMenu();
  	});
	}


	function closeSubMenu() {
		timer2 = setTimeout(function() {
			$submenu.removeClass(activeClass);
		}, 300);


	}

	init();
};

/*
----------------------------------------------------------------------------
XX. Top Promo Bar
----------------------------------------------------------------------------
*/
SDG.promo = function() {

  var c = {
		slider 				: '#topPromoBar',
		li_el 				: '.top-promo__item',
		main_site			: '.main-site',
		hdr					: '#mainHdr',
		class 				: {
			selected 		: 'flex-active-slide',
			promo_class	: 'top-promo--enabled',
			hdr_class 	: 'header__fixed--promo',
		}
	};

  function init() {
		promoSlider();
	}

  function promoSlider() {
    var $slides;

    if ($(c.slider).length > 0) {
      $(c.slider).flexslider({
          animation: 'fade',
          directionNav: false,
          slideshowSpeed: 10000,
          start: function(slider) {
              $slides = $(c.slider).find(c.li_el);

              if ($slides.length === 1) {
                  $(c.slider).find(c.li_el).addClass(c.class.selected);
              }
          }
      });
      $(c.main_site).addClass(c.class.promo_class);
      $(c.hdr).addClass(c.class.hdr_class);
    }
	}

	init();
};


/**
 * header functions
 * @type {Object}
 */
var headerFunctions = {

	/**
	 * init
	 */
	init: function() {
		this.miniCart();
		this.search();
		this.accountBtn();
		this.getNavImage();
		this.showNavImage();
		this.mobileMenu();

		if (jeSettings.giftbox_active === 'yes') {
			giftbox.init();
		}
	},

	/**
	 * mini cart
	 */
	miniCart: function() {
		var excludeSelectors = '.js-donation,.modal-donation,.modal-donation__close,.modal-donation__inner,.modal-donation__content,p,strong,.icons';

		__.clickOutside({
			callback: closeCart,
			condition: isActive,
			exclude_selectors: excludeSelectors,
			selector: '#sidebarCart',
		});

		$('.js-open-cart').click(function(e) {
			e.preventDefault();

			var bodyTop = $('body').scrollTop();
			$('body').attr('data-top', bodyTop);

			if ($('body').hasClass('drawer-open') && ($('.sidebar-search').hasClass('is-open') || $('.sidebar-menu').hasClass('is-open'))) {
				$('.sidebar-cart').addClass('is-open');
				$('.sidebar-search').removeClass('is-open');
				$('.sidebar-menu').removeClass('is-open');
			}
			else if ($('body').hasClass('drawer-open')) {
				closeCart();
			}
			else {
				$('.sidebar-cart').addClass('is-open');
				$('body').addClass('drawer-open');
			}

			return false;
		});

		$('.sidebar-cart__close').on('click', function() {
			closeCart();
		});

		function closeCart() {
			$('body').removeClass('drawer-open');
			$('.sidebar-cart').removeClass('is-open');
			if ($('.fixed_header').css('position') === 'fixed') {
				$('html, body').animate({
					scrollTop: $('body').attr('data-top')
				}, 0);
			}
		}

		function isActive() {
			return $('.sidebar-cart').hasClass('is-open');
		}

		// ajaxAddToCart.updateCart();
	},

	/**
	 * search
	 */
	search: function() {
		var excludeSelectors = '.ss__query';

		__.clickOutside({
			callback: closeSearch,
			condition: isActive,
			exclude_selectors: excludeSelectors,
			selector: '#sidebarSearch',
		});

		$('.js-open-search').click(function(e) {
			e.preventDefault();

			var bodyTop = $('body').scrollTop();
			$('body').attr('data-top', bodyTop);

			if ($('body').hasClass('drawer-open') && ($('.sidebar-menu').hasClass('is-open') || $('.sidebar-cart').hasClass('is-open'))) {
				$('.sidebar-search').addClass('is-open');
				$('.sidebar-menu').removeClass('is-open');
				$('.sidebar-cart').removeClass('is-open');
			}
			else if ($('body').hasClass('drawer-open')) {
				closeSearch();
			}
			else {
				$('.sidebar-search').addClass('is-open');
				$('body').addClass('drawer-open');
			}

			$('#ssQuery').focus();

			return false;
		});

		$('.sidebar-search__close').on('click', function() {
			$('#ssInput').val('');
			closeSearch();
			$('body').trigger('click');
		});

		function closeSearch() {
			$('body').removeClass('drawer-open');
			$('.sidebar-search').removeClass('is-open');
			if ($('.fixed_header').css('position') === 'fixed') {
				$('html, body').animate({
					scrollTop: $('body').attr('data-top')
				}, 0);
			}
		}

		function isActive() {
			return $('.sidebar-search').hasClass('is-open');
		}
	},

	/**
	 * account btn
	 */
	accountBtn: function() {

		var accountis = 'closed';
		$('.go_accountx').click(function() {

			if (accountis === 'open') {
				$('.account_drop').hide();
				accountis = 'closed';
			} else {
				$('.account_drop').show();
				accountis = 'open';
			}

			return false;
		});

	},



	/**
	 * Nav Images
	 */
	getNavImage: function() {
		var collectionLinks = $('#menu2 .js-nav');

		$.each(collectionLinks, function() {
			var $navLink = $(this),
				handle = $navLink.data('collection-handle');

			$.ajax({
				url: '/collections/' + handle + '?view=json',
				type: 'GET',
				success: function(resp) {
					var data = JSON.parse(resp);

					var imgUrl = data.imgUrl;
					if (typeof imgixUrl !== 'undefined' && imgixUrl !== '') {
						var filename = imgUrl.split('/products/')[1];
						imgUrl = imgixUrl + '/products/' + filename + imgixParam;
					}
					$navLink.attr('data-product-image', imgUrl);
					if (data !== '') {
						$navLink.addClass('js-nav-hover');
					}
				}
			});
		});

	},
	showNavImage: function() {
		// var collectionLinks = $('#menu2 .js-nav-hover');

		// $.each(collectionLinks, function() {
		// 	var linkImageSrc = $(this).data('product-image');
		// 	$('#navHoverImg').remove();

		// 	$(document).on('mouseover', this, function(event) {
		// 		addImage(linkImageSrc, event);
		// 	}, function() {
		// 		$('#navHoverImg').remove();
		// 	});
		// });

		$(document).on('mouseover', '.js-nav-hover', function(event) {
			var linkImageSrc = $(this).data('product-image');
			$('#navHoverImg').remove();

			addImage(linkImageSrc, event);
		});

		$(document).on('mouseout', '.js-nav-hover', function(event) {
			$('#navHoverImg').remove();
		});

		function addImage(src, e) {
			var appendix = $(e.target).closest('.submenu__inner');
			var html = '';
			html += '<div id="navHoverImg" class="submenu__prod-img-wrap">' +
						'<div  class="submenu__prod-img">' +
							'<img src="'+ src +'" class="" />' +
						'</div>' +
					'</div>';

			appendix.append(html);
		}
	},

	/**
	 * mobile menu
	 */
	mobileMenu: function() {

		$('.js-open-menu').click(function(e) {
			e.preventDefault();

			var bodyTop = $('body').scrollTop();
			$('body').attr('data-top', bodyTop);


			if ($('body').hasClass('drawer-open') && ($('.sidebar-cart').hasClass('is-open') || $('.sidebar-search').hasClass('is-open'))) {
				$('.sidebar-menu').addClass('is-open');
				$('.sidebar-search').removeClass('is-open');
				$('.sidebar-cart').removeClass('is-open');
			}
			else if ($('body').hasClass('drawer-open')) {
				$('.sidebar-menu').removeClass('is-open');
				$('body').removeClass('drawer-open');
			}else {
				$('.sidebar-menu').addClass('is-open');
				$('body').addClass('drawer-open');
			}

			return false;
		});

		$('.sidebar-menu__close').on('click', function() {
			$('body').removeClass('drawer-open');
			$('.sidebar-menu').removeClass('is-open');

			if ($('.fixed_header').css('position') === 'fixed') {
				$('html, body').animate({
					scrollTop: $('body').attr('data-top')
				}, 0);
			}
		});

		$('.js-nav-trigger').on('click', function() {

			$(this).siblings('.submenu__wrap').addClass('is-active');
		});

		$('.js-nav-back').on('click', function() {
			$(this).parent().removeClass('is-active');
		});
	},

	/**
	 * set cart count
	 * @param {number} itemCount
	 */
	setCartCount: function(itemCount) {
		$('.header__right-list--cart').find('.cart-count').text(itemCount);
		$('#mobileMenuWrapper').find('.mobile-menu__count').text(itemCount);
	}
};

/**
 * gift box
 * if item is more than $100, show gift box option
 * @type {Object}
 */
var giftbox = {

	active: true,
	inCart: false,

	/**
	 * init
	 */
	init: function() {
		this.observe();
		this.checkItemInCart();
	},

	/**
	 * observe
	 */
	observe: function() {

		var self = this;

		$('.info_giftbox').click(function() {
			$('.info_description').toggleClass('collapse').slideToggle(300);
		});

		$('#giftbox').on('click', function() {

			if ($(this).is(':checked')) {
				self.addToCart();
			} else {
				self.removeFromCart();
			}

		});
	},

	/**
	 * check item in cart
	 * @param {boolean} giftboxExclude
	 */
	checkItemInCart: function(giftboxExclude) {
		var itemCount = Shopify.cart ? Shopify.cart.item_count : 0;
		var self = this;

		if (giftboxExclude === undefined) giftboxExclude = false;

		if (itemCount > 0) {
			$.each(Shopify.cart.items, function(idx, item) {
				if (item.handle === jeSettings.giftbox_product) {
					$('#sidebarCart').find('#giftbox').prop('checked', true);
					itemCount -= 1;
					self.inCart = true;
				}
				headerFunctions.setCartCount(itemCount);
			});
		} else {
			headerFunctions.setCartCount(0);
		}

		if (itemCount > 3 || itemCount === 0) { // hide giftbox if item > 3
			this.active = false;
		}

		if (this.active) {
			this.activate(true);
		} else {
			this.activate(false);
			this.active = false;
		}
	},

	/**
	 * activate
	 * @param {boolean} status
	 */
	activate: function(status) {
		if (status) {
			// show giftbox
			$('#sidebarCart').find('.items').addClass('giftbox-on');
			$('.mini_cart_giftbox').addClass('active');

		} else {
			// hide giftbox
			$('#sidebarCart').find('.items').removeClass('giftbox-on');
			$('.mini_cart_giftbox').removeClass('active');

			if (this.inCart) {
	            this.removeFromCart(false); // also remove giftbox from cart
	        }

			$('#sidebarCart').find('#giftbox').prop('checked', false); // remove checked checkbox
		}

	},

	/**
	 * add to cart
	 */
	addToCart: function() {
		var self = this;
		var params = {
			url: '/cart/add.js',
			data: {
				quantity: 1,
				id: giftboxId
			},
			dataType: 'json',
			success: function(data) {
				self.inCart = true;
				ajaxAddToCart.updateSubtotal();
			},
			error: function(XMLHttpRequest, textStatus) {
				Shopify.onError(XMLHttpRequest, textStatus);
			}
		};
		$.ajax(params);
	},

	/**
	 * remove from cart
	 * @param {boolean} refreshCart
	 */
	removeFromCart: function(refreshCart) {
		var self = this;
		if (refreshCart === undefined) refreshCart = true;
		var params = {
			url: '/cart/update.js',
            data: 'updates['+giftboxId+']=0',// {updates: {: 0}},
            dataType: 'json',
            success: function() {
            	self.inCart = false;
            	if (refreshCart) {
            		ajaxAddToCart.updateSubtotal();
            	}
            },
            error: function(XMLHttpRequest, textStatus) {
            	Shopify.onError(XMLHttpRequest, textStatus);
            }
        };
        $.ajax(params);
    }
};

/**
 * cart vars - used within ajaxAddToCart
 * @type {Object}
 */
var cartVars = {
	maxQty : 4,
	requestedQty : null,
	itemAdded : null,
	prodName : null,
	remainingQty : null,
	exceededMax : false
};

/**
 * ajax add to cart
 * @type {Object}
 */
var ajaxAddToCart = {
	container: '#sidebarCart',

	/**
	 * init
	 */
	init: function() {
		this.addToCart();
		this.incrementer();
		this.remove();
	},

	/**
	 * add to cart
	 */
	addToCart: function() {
		var shopifyAjaxAddURL = '/cart/add.js';
		var self = this;

		$(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
			e.preventDefault();

			cartVars.requestedQty = null;
			cartVars.itemAdded = null;
			cartVars.prodName = null;
			cartVars.remainingQty = null;
			cartVars.exceededMax = false;

			var $form = $(this),
				currItems = Shopify.cart.items,
				currItemInCart = false,
				currItem = '',
				currentItemQty,
				formData = $form.serialize();

			var data = {};

			if ($form.find('select[name="id"]').val() === '') {
				$('#variantSwitcher').addClass('is-error');
				$('.collection-size').addClass('is-error'); // for quickview
				return;
			} else {
				$('#variantSwitcher').removeClass('is-error');
				$('.collection-size').removeClass('is-error');
			}

			$form.find('input, textarea, select').each(function(i, field) {
			    data[field.name] = field.value;
			});

			for (var k in currItems) {
				if (currItems.hasOwnProperty(k)) {
					var item = currItems[k];

					if (item.id === data.id) {
						currItemInCart = true;
						currItem = item.id;
						currentItemQty = parseInt(item.quantity);
					}
				}
			}

			if (currItemInCart) {

				var qtyToAdd = parseInt(data.quantity),
					newQty = qtyToAdd,
					cartItemQtyInput = $('#sidebarCart').find('.quantity[data-id="'+ currItem +'"]');

				cartVars.remainingQty = cartVars.maxQty - currentItemQty;
				cartVars.requestedQty = (qtyToAdd + currentItemQty);
				cartVars.itemAdded = currItem;
				cartVars.prodName = cartItemQtyInput.parents('.details').find('.title').text();

				if (cartVars.requestedQty > cartVars.maxQty) {
					cartVars.exceededMax = true;

					newQty = cartVars.remainingQty;
				}

				var newFormData = 'id=' + currItem + '&quantity='+ newQty + '&properties%5B_key%5D='+ data['properties[_key]'] + '&properties%5BCountry+of+Origin%5D='+ data['properties[Country of Origin]'] + '&properties%5BFabric+Composition%5D='+ data['properties[Fabric Composition]'];

				formData = newFormData;
			}

			//Disable add button
			$form.find('input[type="submit"]').attr('disabled', 'disabled').each(function() {
				$(this).data('previous-value', $(this).val());
			}).val('Adding...');

			//Add to cart
			$.post(shopifyAjaxAddURL, formData, function(itemData) {

				var itemDataJSON = $.parseJSON(itemData),
					qtyAdded = '';

				//Enable add button
				$form.find('input[type="submit"]').removeAttr('disabled').each(function() {
					var $btn = $(this);
					//Set to 'DONE', alter button style, wait a few secs, revert to normal
					if (jeSettings.product_handle === 'gift-card') {
						$btn.val(jeSettings.text_addtocart_added_giftcard).addClass('inverted');
					} else {
						$btn.val(jeSettings.text_addtocart_added).addClass('inverted');
					}

					window.setTimeout(function() {
						$btn.removeClass('inverted').val($btn.data('previous-value'));
					}, 3000);
				});

				if (itemDataJSON.quantity > 1) {
					qtyAdded = itemDataJSON.quantity + ' items';
				} else {
					qtyAdded = itemDataJSON.quantity + ' item';
				}

				$('#sidebarCart').find('.mini_cart_added').html(qtyAdded + ' added to your cart');

			}, 'text')

			.done(function() {
				self.updateCart();
				$('#sidebarCart').find('.mini_cart_empty').addClass('hide');
				$('.sidebar-cart').find('.bottom').removeClass('hide');
				$('body').addClass('drawer-open');
				$('.sidebar-cart').addClass('is-open');
			})

			.fail(function(data) {
				// alert('We\'re sorry, this product is out of stock.');

				//Enable add button
				$form.find('input[type="submit"]').removeAttr('disabled').each(function() {
					$(this).val($(this).data('previous-value'));
				});

				$form.find('.ddChild').find('.selected').addClass('disabled');

				//Not added, show message
				if (typeof(data) !== 'undefined' && typeof(data.status) !== 'undefined') {
					var $formSubmit = $form.find('input[type="submit"]:first'),
						jsonRes = $.parseJSON(data.responseText),
						quickPopup = SDG.showQuickPopup(jsonRes.description, $formSubmit);

					quickPopup.init();
				} else {
					//Some unknown error? Disable ajax and add the old-fashioned way.
					$form.addClass('noAJAX');
					$form.submit();
				}
			});

			return false;

		});
		$(window).scroll(function() {
			//Hide notifications on scroll
			$('#cart-summary-overlay #shop-more').triggerHandler('click');
		});

	},

	/**
	 * update cart
	 * @param {boolean} refreshCart
	 */
	updateCart: function(refreshCart) {
		var self = this;
		if (refreshCart === undefined) refreshCart = true;

		//Get current cart state
		$.getJSON('/cart.js', function(cartData) {
			var item = '';
			var gwpItem = '';
			var subtotal_original = 0;
			var giftboxExclude = false;
			var bfMessage = document.querySelector('.js-bf-message');

			// moves GWP to bottom of cart
			cartData.items.forEach(function(cartProp, i) {
				if (cartProp.properties.gwp) {
					cartData.items.push(cartData.items[i]);
					cartData.items.splice(i, 1);
					return cartData.items;
				}
			});

			Shopify.cart = cartData;

			// checks if Black Friday Raffle cart message is enabled
			if (bfMessage !== null) {
				var cartTotal = cartData.total_price/100;
				var threshold = parseInt(bfMessage.dataset.threshold);

				// if cart total is greater than threshold, show message - else hide message
				if (cartTotal >= threshold) {
					if (bfMessage.classList.contains('hide')) {
						bfMessage.classList.remove('hide');
					}
				} else {
					if (!bfMessage.classList.contains('hide')) {
						bfMessage.classList.add('hide');
					}
				}
			}

			$.when.apply($, cartData.items.map(function(product) {
				var compare_price = 0,
				max_inventory = 0;
				var variant_id = product.variant_id;

				return $.getJSON('/products/' + product.handle + '.js', function(data) {

					if (data.tags.indexOf('giftbox_exclude') !== -1 && giftboxExclude === false) {
						// if item in cart contains giftbox_exclude tag
						giftboxExclude = true;
					}

					if (data.compare_at_price !== null) {
						compare_price = data.compare_at_price;
						subtotal_original += product.quantity * data.compare_at_price;
					} else {
						subtotal_original += product.quantity * data.price;
					}


					$.each(data.variants, function() {
						if (this.id === variant_id) {
							max_inventory = 4;
						}
					});

				}).then(function(data) {
					var productProps = product.properties;
					console.log(product)
					// console.log('props ', productProps)
					// console.log('product ', product)

					if (!productProps.hasOwnProperty('gwp')) {

						if (product.handle !== jeSettings.giftbox_product) {

							var imgUrl = product.image;
							if (typeof imgixUrl !== 'undefined' && imgixUrl !== '') {
								var filename = imgUrl.split('/products/')[1];
								imgUrl = imgixUrl + '/products/' + filename;
							}
							var sizing_split = product.variant_options[2].split('/');
							var sizing_title = sizing_split.length > 1 ? sizing_split[1] : product.variant_options[2].replace('EU ','');

							if (productProps.hasOwnProperty('gwp')) {
								item += '<h2 class="gwp-items__heading">COMPLIMENTARY GIFT</h2>';
							}
							item += '<div class="item" data-id="'+product.id+'" data-quantity="'+product.quantity+'">';
							item += '<div class="item__content">';
							item += '<div class="image">';
							item += '<a href="'+product.url+'">';
							item += '<img class="cartimage" src="'+imgUrl+'"  alt="'+product.title+'" />';
							item += '</a></div><div class="details">';
							item += product.gift_card ? '<span class="title bold">'+product.title.split('-')[0]+'</span><br />' : '<span class="title bold">'+product.title.split('/')[0]+'</span>';
							item += !product.gift_card ? '<ul class="details__list list-reset">' : '';
							item += !product.gift_card ? '<li class="details__price">' : '';
							if (productProps.hasOwnProperty('gwp') === false) {
								if (compare_price > 0) {
									item += '<span class="compare_at compare_at--item">'+Shopify.formatMoney(compare_price).replace('.00','')+'</span> ';
								}
								item += Shopify.formatMoney(product.price).replace('.00','') + '</li>';
							} else {
								item += '<span class="compare_at compare_at--item">'+Shopify.formatMoney(product.price).replace('.00','')+'</span> ';
								item += '$0' + '</li>';
							}
							if (product.product_type !== 'Books') {
								item += !product.gift_card ? '<li>' + product.variant_options[2] + '</li>' ? '<li>Size: ' + sizing_title + '</li>' : '' : '';
								item += !product.gift_card ? '<li>' + product.variant_options[1] + '</li>' ? '<li>Color: ' + product.variant_options[1] + '</li>' : '' : '';
							}
							item += '</ul>';
							item += '<div class="details__actions">';
							if (productProps.hasOwnProperty('gwp')) {
								item += '<div class="quantity-wrapper"><input type="text" class="quantity" data-id="'+product.variant_id+'" style="pointer-events: none" value="'+(product.quantity > 9 ? product.quantity : '0' + product.quantity)+'" max="'+max_inventory+'" /></div>';
							} else {
								item += '<div class="quantity-wrapper"><span class="dec">&ndash;</span><input type="text" class="quantity" data-id="'+product.variant_id+'" value="'+(product.quantity > 9 ? product.quantity : '0' + product.quantity)+'" max="'+max_inventory+'" /><span class="inc">+</span></div>';
							}
							item += '<div class="details__wrap">';
							item += '<div class="remove" data-id="'+product.variant_id+'">Remove</div>';
							item += '<div class="wishlist product_'+ product.variant_id + '" data-id="'+product.id+'" data-variant-id="'+product.variant_id+'" data-handle="'+product.handle+'" data-price="'+(product.price / 100)+'" data-image="'+product.image+'">Move to wishlist</div>';
							item += '</div>';

							if (product.properties) {
								if (product.properties.Note !== '' && typeof product.properties.Note !== 'undefined') {
									item += '<div class="message-area">'+product.properties.Note+'</div>';
								}
								if (product.properties.Cart_Message_2 !== '' && typeof product.properties.Cart_Message_2 !== 'undefined') {
									item += '<div class="message-area">'+product.properties.Cart_Message_2+'</div>';
								}
								if (productProps.hasOwnProperty('gwp')) {
									item += '<p class="gwp-policy">* LIMITED TO ONE PER PERSON	<br> THIS ITEM IS A GIFT AND CANNOT BE RETURNED OR EXCHANGED</p>';
								}
							}

							item += '</div>';
							item += '</div>'; // close 'item class'

							item += '</div>';
							item += '</div>';
						}
					} else {
						if (product.handle !== jeSettings.giftbox_product) {

							var imgUrl = product.image;
							if (typeof imgixUrl !== 'undefined' && imgixUrl !== '') {
								var filename = imgUrl.split('/products/')[1];
								imgUrl = imgixUrl + '/products/' + filename;
							}
							var sizing_split = product.variant_options[2].split('/');
							var sizing_title = sizing_split.length > 1 ? sizing_split[1] : product.variant_options[2].replace('EU ','');

							if (productProps.hasOwnProperty('gwp')) {
								gwpItem += '<h2 class="gwp-items__heading">COMPLIMENTARY GIFT</h2>';
							}
							gwpItem += '<div class="item" data-id="'+product.id+'" data-quantity="'+product.quantity+'">';
							gwpItem += '<div class="item__content">';
							gwpItem += '<div class="image">';
							gwpItem += '<a href="'+product.url+'">';
							gwpItem += '<img class="cartimage" src="'+imgUrl+'"  alt="'+product.title+'" />';
							gwpItem += '</a></div><div class="details">';
							gwpItem += product.gift_card ? '<span class="title bold">'+product.title.split('-')[0]+'</span><br />' : '<span class="title bold">'+product.title.split('/')[0]+'</span>';
							gwpItem += !product.gift_card ? '<ul class="details__list list-reset">' : '';
							gwpItem += !product.gift_card ? '<li class="details__price">' : '';
							if (productProps.hasOwnProperty('gwp') === false) {
								if (compare_price > 0) {
									gwpItem += '<span class="compare_at compare_at--item">'+Shopify.formatMoney(compare_price).replace('.00','')+'</span> ';
								}
								gwpItem += Shopify.formatMoney(product.price).replace('.00','') + '</li>';
							} else {
								gwpItem += '<span class="compare_at compare_at--item">'+Shopify.formatMoney(product.price).replace('.00','')+'</span> ';
								gwpItem += '$0' + '</li>';
							}
							if (product.product_type !== 'Books') {
								gwpItem += !product.gift_card ? '<li>' + product.variant_options[2] + '</li>' ? '<li>Size: ' + sizing_title + '</li>' : '' : '';
								gwpItem += !product.gift_card ? '<li>' + product.variant_options[1] + '</li>' ? '<li>Color: ' + product.variant_options[1] + '</li>' : '' : '';
							}
							gwpItem += '</ul>';
							gwpItem += '<div class="details__actions">';
							if (productProps.hasOwnProperty('gwp')) {
								gwpItem += '<div class="quantity-wrapper"><input type="text" class="quantity" data-id="'+product.variant_id+'" style="pointer-events: none" value="'+(product.quantity > 9 ? product.quantity : '0' + product.quantity)+'" max="'+max_inventory+'" /></div>';
							} else {
								gwpItem += '<div class="quantity-wrapper"><span class="dec">&ndash;</span><input type="text" class="quantity" data-id="'+product.variant_id+'" value="'+(product.quantity > 9 ? product.quantity : '0' + product.quantity)+'" max="'+max_inventory+'" /><span class="inc">+</span></div>';
							}
							gwpItem += '<div class="details__wrap">';
							gwpItem += '<div class="remove gwp-remove" data-id="'+product.variant_id+'">Remove</div>';
							gwpItem += '<div class="wishlist gwp-remove product_'+ product.variant_id + '" data-id="'+product.id+'" data-variant-id="'+product.variant_id+'" data-handle="'+product.handle+'" data-price="'+(product.price / 100)+'" data-image="'+product.image+'">Move to wishlist</div>';
							gwpItem += '</div>';

							if (product.properties) {
								if (product.properties.Note !== '' && typeof product.properties.Note !== 'undefined') {
									gwpItem += '<div class="message-area">'+product.properties.Note+'</div>';
								}
								if (product.properties.Cart_Message_2 !== '' && typeof product.properties.Cart_Message_2 !== 'undefined') {
									gwpItem += '<div class="message-area">'+product.properties.Cart_Message_2+'</div>';
								}
								if (productProps.hasOwnProperty('gwp')) {
									gwpItem += '<p class="gwp-policy">* LIMITED TO ONE PER PERSON	<br> THIS ITEM IS A GIFT AND CANNOT BE RETURNED OR EXCHANGED</p>';
								}
							}

							gwpItem += '</div>';
							gwpItem += '</div>'; // close 'item class'

							gwpItem += '</div>';
							gwpItem += '</div>';
						}

						if (cartData.item_count === 1 && productProps.hasOwnProperty('gwp')) {
							var variantId = product.variant_id;
							$.ajax({
								type: "POST",
								url: "/cart/change.js",
								dataType: "json",
								data: {
									id: parseFloat(variantId),
									quantity: 0,
								},
								success: function(data) {
									ajaxAddToCart.updateSubtotal();
									ajaxAddToCart.updateCart();
									$.cookie('enableGwp', 'true');
								},
							});
						}
					}
				});

			})).then(function() {

				// all ajax calls done now

				if (giftboxExclude) {
					// hide giftbox when gift_exclude item in cart
					giftbox.active = false;
				}

				if (refreshCart) {

					$(self.container).find('.items').html(item);
					$(self.container).find('.gwp-added').html(gwpItem).removeClass('hide');

					if (cartVars.exceededMax) {
						var cartItemQtyInput = $('#sidebarCart').find('.quantity[data-id="'+ cartVars.itemAdded +'"]').parents('.quantity-wrapper');

						cartItemQtyInput.after('<span class="quantity-wrapper__message">No more ' + cartVars.prodName + ' are available at this time.</span>');
					}
				}

				// re-enable gwp feature if the cart does not contain any gwp items
				const cartContainsGwp = !!cartData.items.find(function(item) { return item.properties.hasOwnProperty('gwp') });
				if (!cartContainsGwp) {
					if ($.cookie('enableGwp') === 'false') {
						// reset gwp config options
						$('#colorSelectedLabel').text('Color');
						$('#sizeSelectedLabel').text('Select ');
						$('#gwpAtcBtn').attr("data-variant", null);
					}
					$.cookie('enableGwp', 'true');
				} else {
					$.cookie('enableGwp', 'false');
				}

				// if cart is not empty and gwp is active
				if (cartData.item_count > 0 && $.cookie('enableGwp') !== 'false') {
					var soloVariant = $('.gwp-container').data('solo-variant');

					if (soloVariant !== true) {
						$('.gwp-container').removeClass('hide');
						var colorUrls = [];
						var selectedVariant = [];

						// grabs gwp variant urls for fetch
						$('#colorOption > span').each(function() {
							var color = $(this).text().toLowerCase().trim();
							var colorUrl = window.location.origin + '/products/' + $('.gwp-container').attr('data-handle') + '-' + color + '.js';
							colorUrls.push(colorUrl);
						});

						// fetches gwp variant data
						function fetchProducts() {
							var urls = colorUrls;
							var results = [];
							var promises = urls.map(function(url) {
								return fetch(url).then(function(res) {
									return res.json();
								});
							});
							Promise.all(promises).then(function(responses) {
								responses.forEach(function(response) {
									results.push(response);
									$( "#colorDropDown" ).empty();
									$( "#sizeDropDown" ).empty();
								});

								// rerenders gwp content based on available variants
								results.forEach(function(product) {
									if (product.available === true) {

										var color = product.title.split('/')[1].trim();
										var productVariants = product.variants;
										var variantIds = [];
										var variantSizes = [];

										productVariants.forEach(function(variant) {

											if (variant.available === true) {
												variantIds.push(variant.id);
												if (variant.option3 !== null) {
													variantSizes.push(variant.option3);
												} else {
													variantSizes.push(variant.option1);
												}
											}
										});

										// renders size dropdown content for selected variant
										variantSizes.forEach(function(size, index) {
											var variantId = variantIds[index];

											$( "#sizeDropDown" ).append( '<li class="gwp-pv-select__item"><button type="button" class="gwp-pv-select__btn btn-link" style="display: none;"' + 'data-variant = '+ product.id + ' data-id=' + variantId + ' id="sizeOption"><span class="gwp-pv-select__btn-label">' + size + '</span></button></li>');


										});

										// renders color dropdown content for selected variant
										$( "#colorDropDown" ).append( '<li class="gwp-pv-select__item"><button type="button" class="gwp-pv-select__btn btn-link"' + 'data-variant = ' + product.id + ' data-image=' + product.featured_image + ' id="colorOption"><span class="gwp-pv-select__btn-label">' + color + '</span></button></li>');

										// rerenders featured image on variant selection
										$(document).on('click', '#colorOption', function() {
											var variantSelected = $(this).attr("data-variant");
											var sizeList = $('#sizeOption[data-variant="' + variantSelected + '"]');

											$('.cartimage-gwp').attr('src', $(this).data('image'));

											$.each(sizeOption, function() {
												$(this).hide();
											});

											$.each(sizeList, function() {
												$(this).show();
											});
										});

										$(document).on('click', '#sizeOption', function() {
											$('#gwpAtcBtn').attr("data-variant", $(this).data('id'));
											selectedVariant.push($(this).data('id'));
										});
									}
								});
								return results;
							});
						}

						fetchProducts();

						// resize gwp configurable dropdown
						$(".gwp-pv-select__list").css({
							'width': ($(".dropdown").width() + 'px')
						});

						// resize gwp configurable dropdown on browser resize
						window.onresize = function() {
							$(".gwp-pv-select__list").css({
								'width': ($(".dropdown").width() + 'px')
							});
						}

						// open gwp color dropdown
						$(document).on('click', '#colorBtn', function() {
							if ($('#colorDropDown').css('opacity') == 0) {
								$('#colorDropDown').css({'opacity': 1, 'z-index': 99});
								$('#sizeDropDown').css({'opacity': 0, 'z-index': -1});

								// select gwp variant color
								$(document).on('click', '#colorOption', function() {
									var selectedColor = $(this).text().trim();
									$('#colorSelectedLabel').text(selectedColor);
									$('#colorDropDown').css({'opacity': 0, 'z-index': -1});
									$('#colorError').css({'display': 'none'});
									$('#colorBtn').css({'border-color': 'black'});
								});

							} else {

								$('#colorDropDown').css({'opacity': 0, 'z-index': -1});
							}
						});

						// open gwp size dropdown
						$(document).on('click', '#sizeBtn', function() {
							if ($('#sizeDropDown').css('opacity') == 0) {
								$('#sizeDropDown').css({'opacity': 1, 'z-index': 99});
								$('#colorDropDown').css({'opacity': 0, 'z-index': -1});

								// select gwp variant size
								$(document).on('click', '#sizeOption', function() {
									var selectedSize = $(this).text().trim();
									$('#sizeSelectedLabel').text(selectedSize);
									$('#sizeDropDown').css({'opacity': 0, 'z-index': -1});
									$("#sizeSelectedLabel").attr('data-selected', selectedSize);
									$('#sizeError').css({'display': 'none'});
									$('#sizeBtn').css({'border-color': 'black'});
								});

							} else {

								$('#sizeDropDown').css({'opacity': 0, 'z-index': -1});
							}
						});

						// disable checkout button if GWP variant not selected
						if (!$('#sizeSelectedLabel').attr('data-selected') && $('#colorSelectedLabel').text() === 'Color') {
							$('#sidecartCheckout').addClass('disabled');
							$(document).on('click', '.mini_cart_btns', function() {

								if (!$('#sizeSelectedLabel').attr('data-selected')) {
									$('#sizeBtn').css({'border-color': 'red'});
									$('#sizeError').css({'display': 'block'});
								}

								if ($('#colorSelectedLabel').text() === 'Color') {
									$('#colorBtn').css({'border-color': 'red'});
									$('#colorError').css({'display': 'block'});
								}

								if ($('#sidecartCheckout').hasClass('disabled')) {
									$('#atcError').css({'display': 'block', top: '0px'});
								}
							});
						}

						// add to cart button
						$(document).off('click.gwpadd').on('click.gwpadd', '#gwpAtcBtn', function() {

							var variantId = parseInt($('#gwpAtcBtn').attr("data-variant"), 10);
							if (variantId) {

								var params = {
									url: '/cart/add.js',
									data: {
										quantity: 1,
										id: variantId,
										properties: {
											"gwp":"true"
										}
									},
									dataType: 'json',
									success: function(data) {
										self.inCart = true;
										ajaxAddToCart.updateSubtotal();
										ajaxAddToCart.updateCart();
										$.cookie('enableGwp', 'false');
										$('#atcError').css({'display': 'none'});
										$('#sidecartCheckout').removeClass('disabled');
									},
									error: function(XMLHttpRequest, textStatus) {
										Shopify.onError(XMLHttpRequest, textStatus);
									}
								};
								$.ajax(params);
							}
						});
					} else {
						// add solo variant gwp to cart
						var gwpSoloVariant = $('#gwpAtcBtn').data('variant-id');

						var params = {
							url: '/cart/add.js',
							data: {
								quantity: 1,
								id: gwpSoloVariant,
								properties: {
									"gwp":"true"
								}
							},
							dataType: 'json',
							success: function(data) {
								self.inCart = true;
								ajaxAddToCart.updateSubtotal();
								ajaxAddToCart.updateCart();
								$.cookie('enableGwp', 'false');
							},
							error: function(XMLHttpRequest, textStatus) {
								Shopify.onError(XMLHttpRequest, textStatus);
							}
						};
						$.ajax(params);
					}

				} else {

					// hide gwp when empty
					$('.gwp-container').addClass('hide');
				}

				if (cartData.item_count > 0) {


					$('#sidebarCart').find('.mini_cart_btn').removeClass('disable');

					// Side cart
					if ($('#minicartDonation').length > 0) {
						$('#minicartDonation').removeClass('hide');
					}

				} else {

					// hide giftbox when empty
					giftbox.active = false;
				}

				self.updateSubtotal(giftboxExclude);
			});
			self.donation();
			self.refreshUpsell(cartData);
		});
	},

	/**
	 * update upsell in cart
	 */
	refreshUpsell: async function(cartData){
		var self = this;
		let tier = '';
		let upsellContainer = document.querySelector(self.container).querySelector('.cart-upsell__container');
		let tierCollection = '';

		for (const item of cartData.items){
			try{
				const response = await fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js');
				const productData = await response.json();
				for (const tag of productData.tags){
					switch(tag){
						case 'Tier1':
							tier = tag;
							break;
						case 'Tier2':
							tier = tag;
							break;
						case 'Tier3':
							tier = tag;
							break;
						case 'Tier4':
							tier = tag;
							break;
						case 'Tier5':
							tier = tag;
							break;
					}
					if (tier != ''){
						break;
					}
				}
			}catch(error){
				console.log(error)
			}
		} 

		switch(tier){
			case 'Tier1':
				tierCollection = upsellContainer.dataset.tier1;
				break;
			case 'Tier2':
				tierCollection = upsellContainer.dataset.tier2;
				break;
			case 'Tier3':
				tierCollection = upsellContainer.dataset.tier3;
				break;
			case 'Tier4':
				tierCollection = upsellContainer.dataset.tier4;
				break;
			case 'Tier5':
				tierCollection = upsellContainer.dataset.tier5;
				break;
		}

		console.log(tierCollection)
		self.initRelatedVariants(tierCollection, cartData)
	},


	initRelatedVariants: async function(tierCollection, cartData) {
		var self = this;
		let upsellInner = document.querySelector(self.container).querySelector('.cart-upsell');
		let upsellTitle = upsellInner.dataset.title;

		console.log(upsellInner)
		if (!tierCollection){
			upsellInner.classList.add('hide')
			return;
		}

    const targetURL = `/collections/${tierCollection}/?view=upsell`;
    const relatedProductsJSON = await self.getRelatedProductsJSON(targetURL);
    let relatedProductsMarkup = `<h2 class="gwp-items__heading upsell-heading">${upsellTitle}</h2>`;

		console.log(relatedProductsJSON)
    if (relatedProductsJSON.length < 1) {
			upsellInner.classList.add('hide')
      return;
    }

		let count = 0;

		function splitOptions(options){
			let splitOptions = options.split(';');
			return splitOptions[2]
		}

		for (const product of relatedProductsJSON){
			const inCart = cartData.items.some(item => item.handle == product.handle);
			if (product.available && !inCart){
				let variantOptions = product.variantOptions;
				let variantIds = product.variantIds;
				let variantAvailability = product.variantAvailability;

				let variantOptionsArray = variantOptions.split(",");
				let variantIdsArray = variantIds.split(",");
				let variantAvailabilityArray = variantAvailability.split(",");
					count++
					relatedProductsMarkup = `${relatedProductsMarkup}
						<div class="gwp-items upsell-item" data-handle="${product.handle}">
							<div class="item test">
								<div class="image">
									<a href="${product.url}">
										<img class="cartimage-gwp" src="${product.image}" alt="${product.title}" />
									</a>
								</div>
			
								<div class="details">
									<span class="title bold">${product.title}</span>
									<ul class="details__list list-reset">
										<li class="details__price">
											${product.compareAtPrice > product.price ? 
												`<span class="compare_at">$${product.compareAtPrice}</span>
												<span class="price">$${product.price}</span>`
											:
												`<span class="price">$${product.price }</span>`
											}
										</li>
									</ul>
			
									<div class="gwp-configurables">
										<div class="gwp-dropdowns">
											${variantIdsArray.length > 1 ?
												`<div class="dropdown">
													<div class="dropbtn" id="sizeBtn">
															<div class="gwp-pv-select__title gwp-pv-select-item">
																<div class="gwp-pv-select__selected">
																	<span class="gwp-pv-select__label" id="sizeSelectedLabel">Select Size</span>
																</div>
																<div class="gwp-pv-select__arrows"></div>
															</div>
														</div>
		
														<p class="dropdown-error" id="sizeError">&#9888; Please Select A Size</p>
		
														<ul class="gwp-pv-select__list list-reset" id="sizeDropDown" style="opacity: 0;">
															${variantAvailabilityArray.map(function (key, index) {
																	if (key == 'true'){
																		return `<li class="gwp-pv-select__item">
																		<button type="button" class="gwp-pv-select__btn btn-link" id="sizeOption" data-id="${variantIdsArray[index]}">
																			<span class="gwp-pv-select__btn-label"> ${splitOptions(variantOptionsArray[index])} </span>
																		</button>
																	</li>`
																	}
															}).join("")}
														</ul>
													</div>`
												:

												``
											}
										</div>
			
										<button type="button" class="gwp-atcBtn" id="upsellAtcBtn" data-variant-id="${variantIdsArray.length == 1 ? `${variantIdsArray[0]}`: ``}">
											ADD TO CART
										</button>
										<p class="dropdown-error" id="upsellError">&#9888; Please Select Options</p>
									</div>
								</div>
							</div>
						</div>
					`
			}

			if (count == 2){
				break;
			}
		}
    
		upsellInner.innerHTML = relatedProductsMarkup;
		upsellInner.classList.remove('hide')

		self.initUpsellButtons();
  },

  getRelatedProductsJSON: function (url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
        return parsedJSON;
      })
  },

	initUpsellButtons: function(){
		let container = document.querySelector(this.container);

		let upsellItems = container.querySelectorAll('.upsell-item');

		upsellItems.forEach((item) => {
			let sizeBtn = item.querySelector('#sizeBtn');
			let dropdown = item.querySelector('#sizeDropDown');
			let label = item.querySelector('#sizeSelectedLabel');
			let error = item.querySelector('#sizeError');
			let sizeOptions = item.querySelectorAll('#sizeOption');
			let upsellAtc = item.querySelector('#upsellAtcBtn');
			let upsellError = item.querySelector('#upsellError')

			if (sizeBtn){
				sizeBtn.addEventListener('click', function(){
					if (dropdown.style.opacity == 0){
						dropdown.style.opacity = 1;
						dropdown.style.zIndex = 99;
						sizeOptions.forEach((option)=> {
							option.addEventListener('click', function(e){
								label.innerText = e.currentTarget.innerText;
								dropdown.style.opacity = 0;
								dropdown.style.zIndex = -1;
								label.setAttribute('data-selected', e.currentTarget.innerText);
								error.style.display = 'none';
								sizeBtn.style.borderColor = 'black';
								upsellAtc.setAttribute('data-variant-id', e.currentTarget.dataset.id);
							})
						})
					}else{
						dropdown.style.opacity = 0;
						dropdown.style.zIndex = -1;
					}
				})
			}

			upsellAtc.addEventListener('click', function(e){
				let variantId = e.currentTarget.dataset.variantId;
				if (variantId){
					var params = {
						url: '/cart/add.js',
						data: {
							quantity: 1,
							id: variantId,
							properties: {
								"_upsell":"true"
							}
						},
						dataType: 'json',
						success: function(data) {
							self.inCart = true;
							ajaxAddToCart.updateSubtotal();
							ajaxAddToCart.updateCart();
							upsellError.style.display = 'none';

						},
						error: function(XMLHttpRequest, textStatus) {
							Shopify.onError(XMLHttpRequest, textStatus);
						}
					};
					$.ajax(params);
				}else{
					upsellError.style.display = 'block';
				}
			})

		})
	},
	/**
	 * incrementer
	 */
	incrementer: function() {
		var self = this;

		$(this.container).on('click', '.inc', function() {
			var qty = $(this).siblings('.quantity'),
			id = qty.attr('data-id'),
			max = qty.attr('max') || 4,
			newQty = parseInt(qty.val()) < parseInt(max) ? parseInt(qty.val()) + 1 : parseInt(max);

			if (newQty < 10) {
				newQty = '0' + newQty;
			}

			self.updateQty(id, newQty);

		});

		$(this.container).on('click', '.dec', function() {
			var qty = $(this).siblings('.quantity'),
			id = qty.attr('data-id'),
			newQty = parseInt(qty.val()) > 0 ? parseInt(qty.val()) - 1 : 0;

			if (newQty > 0 && newQty < 10) {
				newQty = '0' + newQty;
			}

			qty.val(newQty);

			if (newQty === 0) {
				$(this).parents('.item').addClass('removed').slideUp(300);
			}
			self.updateQty(id, newQty);

		});
	},

	/**
	 * remove
	 */
	remove: function() {
		var self = this;
		$(this.container).on('click', '.remove', function() {
			var id = $(this).attr('data-id');

			$(this).parents('.item').addClass('removed').slideUp(300);
			self.updateQty(id, 0);

			self.updateCart(false);
		});

		// remove gwp item
		$(this.container).on('click', '.gwp-remove', function() {
			$('.gwp-items').addClass('hide');
			$.cookie('enableGwp', 'true');
			$('.gwp-added').addClass('hide');
			$('#sidecartCheckout').removeClass('disabled');
		});

		$(this.container).on('click', '.wishlist', function() {
			var $wishlistBtn = $(this);
			var id = $wishlistBtn.attr('data-id');
			var variantId = $wishlistBtn.attr('data-variant-id');
			var handle = $wishlistBtn.attr('data-handle');
			var price = $wishlistBtn.attr('data-price');
			var image = $wishlistBtn.attr('data-image');

			if (window._swat) {
				// eslint-disable-next-line
				window._swat.addToWishList(
					{
						epi: id,
						empi: variantId,
						du: 'https://www.johnelliott.com/products/' + handle,
						pr: price,
						iu: image,
						et: 4,
						stk: 100,
					},
					function() {
						$wishlistBtn.parents('.item').addClass('removed').slideUp(300);
						self.updateQty(id, 0);

						self.updateCart(false);
					}
				);
			} else {
				$(this).parents('.item').addClass('removed').slideUp(300);
				self.updateQty(id, 0);

				self.updateCart(false);
			}
		});
	},

	/**
	 * update qty
	 * @param {number} id  variant id
	 * @param {number} qty quantity number
	 */
	updateQty: function(id, qty) {
		var self = this;

		$.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: {
				quantity: qty,
				id: id
			},
			success: function(data) {
				var qtyInput = $('#sidebarCart').find('.quantity[data-id="'+ id +'"]'),
					prodName = qtyInput.parents('.details').find('.title').text(),
					items = data.items,
					itemData = '';

				for (var k in items) {
					if (items.hasOwnProperty(k)) {
						var item = items[k];

						if (item.id === parseInt(id)) {
							itemData = item;
						}
					}
				}

				var showError  = (qtyInput.val() >= 4 && qty >= 4 ? true : false);

				if (!showError) {
					qtyInput.val(qty);
				}

				if (qty > itemData.quantity || showError) {
					var finalQty = itemData.quantity;

					finalQty = (finalQty >= 5 ? 4 : finalQty);

					if (finalQty < 10) {
						finalQty = '0' + finalQty;
					}

					if (finalQty === '00') {
						finalQty = 0;
					}

					qtyInput.val(finalQty);
					qtyInput.parents('.details').find('.quantity-wrapper__message').remove();
					qtyInput.parents('.quantity-wrapper').after('<span class="quantity-wrapper__message">No more ' + prodName + ' are available at this time.</span>');

				} else {
					qtyInput.parents('.details').find('.quantity-wrapper__message').remove();
				}

				if (giftbox.inCart && data.item_count === 1) {
					// clear cart when only giftbox in cart
					self.clearCart();

				} else {
					if (data.item_count > 0) {
						//cart not empty
						$('#sidebarCart').find('.mini_cart_btn').removeClass('disable');

						self.updateCart(false);
					} else {
						// cart is empty
						self.clearCart();
					}
				}
			},
			error: function() {
				console.warn('You have reached the maximum quantity');
			},
			dataType: 'json'
		});
	},

	/**
	 * clear cart
	 */
	clearCart: function() {
		var self = this;
		var params = {
			url: '/cart/clear.js',
			dataType: 'json',
			success: function(data) {
				$('#sidebarCart').find('.mini_cart_empty').removeClass('hide');
				$('#sidebarCart').find('.mini_cart_btn').addClass('disable');
				$('#sidebarCart').find('.mini_cart_added').html('');
				self.updateCart();
			}
		};
		$.ajax(params);
	},

	/**
	 * update subtotal
	 * @param {boolean} giftboxExclude
	 */
	updateSubtotal: function(giftboxExclude) {
		var self = this;
		if (giftboxExclude === undefined) giftboxExclude = false;

		if (!giftboxExclude) {
			// item in cart don't have giftbox_exclude tag
			giftbox.active = true;
		}

		//Get current cart state
		$.getJSON('/cart.js', function(cartData) {
			var subtotal_original = 0;

			Shopify.cart = cartData;

			$.when.apply($, cartData.items.map(function(product) {
				return $.getJSON('/products/' + product.handle + '.js', function(data) {

					if (data.compare_at_price !== null) {
						subtotal_original += product.quantity * data.compare_at_price;
					} else {
						subtotal_original += product.quantity * data.price;
					}

				});
			})).then(function() {

				var totalInCart = cartData.total_price;

				// exclude gwp discounts from the subtotal
				cartData.items.forEach(function(item) {
					if (item.properties.hasOwnProperty('gwp')) {
						subtotal_original -= item.total_discount;
					}
				})

				if (subtotal_original > cartData.total_price) {
					$(self.container).find('.subtotal').html('Estimated Total: <span class="compare_at">' + Shopify.formatMoney(subtotal_original).replace('.00', '') + '</span>' + '<span class="price">' + Shopify.formatMoney(cartData.total_price).replace('.00', '') + '</span>' + '');
				} else {
					$(self.container).find('.subtotal').html('Estimated Total: <span class="price">' + Shopify.formatMoney(cartData.total_price).replace('.00', '') + '</span>');
				}

				if (totalInCart < 10000) { // if total more than 100 USD
					giftbox.active = false;
				}

				giftbox.checkItemInCart(giftboxExclude);
				self.updateAfterPay(cartData);
			});
		});
	},

	/**
	 * donation
	 */
	donation: function() {
		var optin = false;
		var donationEnabled = SDG.Data.donationEnabled;
		var $donationCheckbox = $('.js-donation');
		var isFirstVisit = sessionStorage.getItem('donation') === null;
		var hasDonation = Shopify.cart.attributes['donation-optin-10%'];
		var hasEmptyCart = $('#sidebarCart .item').length === 0;

		if (!donationEnabled) return;

		if (hasDonation === undefined && (isFirstVisit || hasEmptyCart)) {
			$donationCheckbox.prop('checked', true);
			optin = true;
			ajax(true);
		} else if (hasDonation === 'true') {
			$donationCheckbox.prop('checked', true);
		}

		$donationCheckbox.off('click').on('click', function() { // preventing event bubbling adding "off"
			if ($(this).is(':checked')) {
				optin = true;
				ajax(true);
			} else {
				optin = false;
				ajax(false);
			}
		});

		function ajax(hasNote) {
			var note = '';
			var data;

			if (hasNote) {
				note = 'opt-in';
			}

			data = {
				'attributes': {
					'donation-optin-10%': optin
				},
				'note': note
			};

			$.ajax({
				url: '/cart/update.js',
				data: data,
				dataType: 'json',
				method: 'POST',
				success: function () {
					if (isFirstVisit || hasEmptyCart) {
						sessionStorage.setItem('donation', 'optin');
					}
				},
				error: function (XMLHttpRequest, textStatus) {
					console.warn(XMLHttpRequest, textStatus);
				}
			});
		}
	},

	/**
	 * update afterpay message
	 * @param {boolean} cartData
	 */
	updateAfterPay: function(cartData) {
		var cartItems = cartData.items;
		var isGiftCard = function (item) { return item.product_type === 'Gift Card'; };
		var hasGiftCardItem = cartItems.some(isGiftCard);
		var totalPrice = cartData.total_price;

		var apCartConfig = {
			priceSelector: '.mini_cart_btns',
			amount: totalPrice,
			locale: 'en_US',
			currency: 'USD',
			giftCard: hasGiftCardItem,
			showUpperLimit: false,
			afterpayLogoColor: 'black',
		};

		$('#sidebarCart').find('.afterpay-paragraph').remove();
		new presentAfterpay(apCartConfig).init();
	}
};

/**
 * Newsletter modal
 */
 var newsletterModal = function(){
	var prefValue = '',
		containerID = '#modal_email_signup',
		$container = $(containerID);
 	/**
 	 * init
 	 */
 	function init() {
		if (SDG.getCookie('newsletter') !== 'yes') {
			initModal();
			addEvents();
		}
 	}

	function initModal() {
		$container.on('click','.js-checkbox',function() {
			var val = $(this).val();
			if ($(this).is(':checked')) {
				prefValue += val+',';
			} else {
				prefValue = prefValue.replace(val+',','');
			}
			$('#modalPreference').val(prefValue.slice(0, -1));
		});

		var newsletter = $('#newsletterModal');
		var show = newsletter[0].dataset.show === 'true';

		if (!show) return;

		$('#newsletterModal').addClass('is-active');
		document.querySelector('body').classList.add('newsletter-open');

		$('#modalSignupBtn').on('click', function(e) {

			gtag_report_conversion();

			if ($('#modalInput').val() !== '' && SDG.validateEmail($('#modalInput').val())) {

				if ($('#modalPrefMens').is(':checked') || $('#modalPrefWomens').is(':checked')) {

					return true;
				} else {
					$container.find('.klaviyo_messages .error_message').empty();
					$container.find('.klaviyo_messages .error_message').html('PLEASE SELECT YOUR PREFERENCE').show();

					e.preventDefault();
					return false;
				}

			} else {
				$container.find('.klaviyo_messages .error_message').empty();
				$container.find('.klaviyo_messages .error_message').html('PLEASE ENTER VALID EMAIL').show();

				e.preventDefault();
				return false;
			}

		});

		KlaviyoSubscribe.attachToForms(containerID, {
			hide_form_on_success: true,
			extra_properties: {
				$source: 'NL_popup'
			},
			success: openThankYouModal
		});
	}

	function addEvents() {
		$('.js-close-modal').on('click', closeModal);
	}

	function closeModal() {
		$('#newsletterModal').removeClass('is-active');
		$('#thankyouNewsletterModal').removeClass('is-active');
		document.querySelector('body').classList.remove('newsletter-open');

		SDG.setCookie('newsletter', 'yes', 7);
	}

	function openThankYouModal() {
		closeModal();

		$('#thankyouNewsletterModal').addClass('is-active');
		clearPreference();
	}

	function clearPreference() {
		prefValue = '';
		$('#modalPreference').val('');
	}

	init();
};

/**
 * input placeholder
 * @requires [lib/util.js]
 * @return   {Object}
 */
SDG.placeholder = function(target) {
	function init() {
		valueHasChanged();

		$(target).each(function() {
			checkValue($(this));
		});
	}

	function valueHasChanged() {
		$('body').on('change keyup', target, function() {
			checkValue($(this));
		});
	}

	function checkValue(field) {
		if ($(field).val() !== '') {
			$(field).parent('.input-placeholder').addClass('has-value');
		} else {
			$(field).parent('.input-placeholder').removeClass('has-value');
		}
	}
	return {
		init: init
	};
};


/**
 * set cookie
 * @param  {String} c_name name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */
SDG.setCookie = function(c_name,value,exdays) {
	var exdate=new Date();
	exdate.setDate(exdate.getDate() + exdays);
	var c_value=encodeURI(value) +
	((exdays===null) ? '' : ('; expires='+exdate.toUTCString()));
	document.cookie=c_name + '=' + c_value +'; path=/';
};

/**
 * get cookie
 * @param  {String} c_name name of the cookie
 * @return {String}        value of the cookie
 */
SDG.getCookie = function(c_name) {
	var i,x,y,ARRcookies=document.cookie.split(';');
	for (i=0;i<ARRcookies.length;i++) {
		x=ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
		y=ARRcookies[i].substr(ARRcookies[i].indexOf('=')+1);
		x=x.replace(/^\s+|\s+$/g,'');
		if (x===c_name) {
			return decodeURI(y);
		}
	}
};

/**
 * delete cookie
 * @param {string} c_name name of the cookie
 */
SDG.deleteCookie = function(c_name) {
	document.cookie = c_name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

/*
 * Validate Email
 */
SDG.validateEmail = function(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

require(['jquery', path.flexslider], function() {
  /**
   * fire functions
   */
  SDG.run();

  jQuery(document).ready(function($) {
  	SDG.runDomReady();
  });
});

SDG.getSizeQueryString = function() {
	var paramsString = window.location.search;
	var searchParams = new URLSearchParams(paramsString);
	return searchParams.get('size');
}

/**
 * App
 */

define('jquery', [], function() {
	return jQuery;
});

if (pageHandle in path) {
	require([
		path[pageHandle],
		path.shopify_options
	]);
}